// import React, { useState, useEffect, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import axios, { removeBracketedText } from '../Axiosinstance';
// import TimesRoman from '../fonts/times.ttf'
// import Charisma from '.././images/Charisma.png'
// import {
//     TextField,
//     Button, IconButton,
//     Grid,
//     Typography,
//     Container,
//     Paper,
//     Box,
//     Dialog,
//     DialogActions,
//     InputAdornment,
//     Checkbox,
//     DialogContent,
//     DialogTitle,
//     FormControl,
//     InputLabel,
//     Select,
//     MenuItem,
//     TableContainer,
//     Table,
//     TableHead,
//     TableRow,
//     TableCell,
//     TableBody,
//     Card,
//     Tooltip,
//     LinearProgress, Slide, CircularProgress
// } from '@mui/material'
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import AddIcon from '@mui/icons-material/Add';
// import DeleteIcon from '@mui/icons-material/Delete';
// import TablePagination from '@mui/material/TablePagination';
// import Header from '../components/Header';
// import Tabs from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';
// import { BsPencilFill, BsTrashFill } from 'react-icons/bs';
// import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
// import * as XLSX from 'xlsx';
// import { toast, ToastContainer } from 'react-toastify';
// import { CLOUDINARY_UPLOAD_PRESET, baseURL } from '../common'
// import Newstudent from './Newstudent'
// import Loader from '../Loader';
// import Modal from 'react-bootstrap/Modal';
// import { useTheme } from '@mui/material/styles';
// import useMediaQuery from '@mui/material/useMediaQuery';
// import ApplicationForm from './ApplicationForm';
// import OfferLetter from '../components/OfferLetter.jsx';
// import Invitation from '../pdf/Invitation.pdf'
// import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
// import icon from '../All/images/tick-icon.png';
// // import icon from '../All/images/tick-icon.png';
// // import fs from 'fs';
// import fontkit from '@pdf-lib/fontkit';  // Import fontkit for custom fonts
// import poppins from '../fonts/Poppins-Regular.ttf';
// import poppinsBold from '../fonts/Poppins-Bold.ttf';
// import courserecipt from '../pdf/courserecipt.pdf'


// const columns = [
//     { id: 'S.NO', label: 'S.NO', minWidth: 170 },
//     { id: 'name', label: 'Name', minWidth: 170 },
//     { id: 'NRIC/FIN No', label: 'NRIC/FIN No', minWidth: 170 },
//     { id: 'email', label: 'Email', minWidth: 170 },
//     { id: 'phone', label: 'Phone', minWidth: 170 },
//     { id: 'gender', label: 'Gender', minWidth: 170 },
//     { id: 'Documents Date', label: 'Documents Date', minWidth: 170 },
//     { id: 'actions', label: 'Actions', minWidth: 170 },
//     // { id: 'Documents', label: 'Documents', minWidth: 170 },
//     // { id: 'OfferLetter', label: 'Offer Letter', minWidth: 170 },
//     // { id: 'Invitation', label: 'Invitation', minWidth: 170 },
//     { id: 'Reciept', label: 'Reciept', minWidth: 170 },
// ];


// const Screen = () => {
//     const [students, setStudents] = useState([]);
//     const [filteredStudents, setFilteredStudents] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [studentsPerPage, setStudentsPerPage] = useState(100);
//     const [searchQuery, setSearchQuery] = useState('');
//     const [filterGender, setFilterGender] = useState('');
//     const [isEditModalOpen, setEditModalOpen] = useState(false);
//     const [editedStudent, setEditedStudent] = useState({});
//     const [pageSize, setPageSize] = useState(10);
//     const [selectedFile, setSelectedFile] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const CLOUDINARY_URL = baseURL;
//     const CLOUDINARY_UPLOAD = CLOUDINARY_UPLOAD_PRESET;
//     const [uploadedImageUrl, setUploadedImageUrl] = useState('');
//     const [isReadOnly, setIsReadOnly] = useState(true);
//     const [dataForprop, setDataForprop] = useState(null);
//     const [showEmploymentFields, setShowEmploymentFields] = useState(false);
//     const [showModal, setShowModal] = useState(false);
//     const [paymentDetails, setPaymentDetails] = useState(false);
//     const [showPassword, setShowPassword] = useState(false);
//     const [selectedStudent, setSelectedStudent] = useState(null);



//     const applicationFormRef = useRef(null);
//     const offerLetterRef = useRef(null)


//     const handleFileChange = (e) => {
//         const file = e.target.files[0];
//         setSelectedFile(file);
//     };
//     const [isEditing, setIsEditing] = useState(false);

//     useEffect(() => {
//         fetchStudents();
//     }, []);


//     const [selectedProfileFile, setSelectedProfileFile] = useState(null);
//     const [selectedNricFile, setSelectedNricFile] = useState(null);
//     const [selectedPassportFile, setSelectedPassportFile] = useState(null);
//     const [selectedEducationFile, setSelectedEducationFile] = useState(null);

//     useEffect(() => {
//         if (editedStudent) {
//             setSelectedProfileFile(null);
//             setSelectedNricFile(null);
//             setSelectedPassportFile(null);
//             setSelectedEducationFile(null);
//         }
//     }, [editedStudent]);

//     const fetchStudents = async () => {
//         try {
//             setLoading(true);
//             const response = await axios.get(
//                 "registrationadvances/registration/status?status=Active"
//             );
//             setStudents(response.data.reverse());
//             setLoading(false);
//         } catch (error) {
//             console.error("Error fetching students:", error);
//             setLoading(false);
//         }
//     };



//     const handleApplicationForm = (student) => {
//         if (applicationFormRef.current) {
//             applicationFormRef.current.handleDownload(student); // Call handlePdfEdit function of the child component
//         }
//     };

//     const handleOfferForm = (student) => {
//         if (offerLetterRef.current) {
//             offerLetterRef.current.handleDownload(student); // Call handlePdfEdit function of the child component
//         }
//     };

//     useEffect(() => {
//         const filtered = students.filter((student) => {
//             if (filterGender) {
//                 return student.gender.toLowerCase() === filterGender.toLowerCase();
//             }
//             return true;
//         });


//         const searchFiltered = filtered.filter((student) =>
//             student.name.toLowerCase().includes(searchQuery.toLowerCase())
//         );


//         setFilteredStudents(searchFiltered);
//     }, [searchQuery, filterGender, students, currentPage, pageSize]);


//     const handleSearch = (event) => {
//         setSearchQuery(event.target.value);
//         setCurrentPage(1); // Reset to the first page when searching
//     };

//     const togglePasswordVisibility = () => {
//         setShowPassword((prev) => !prev);
//     };

//     const handleFilterGender = (gender) => {
//         setFilterGender(gender);
//         setCurrentPage(1); // Reset to the first page when applying filters
//     };

//     const [showDeleteModal, setShowDeleteModal] = useState(false);
//     const [deletingStudentId, setDeletingStudentId] = useState(null);

//     const DeleteConfirmationModal = ({ show, handleClose, handleConfirm }) => {
//         return (
//             <Modal show={show} onHide={handleClose} centered>
//                 <Modal.Header closeButton>
//                     <Modal.Title>Delete Confirmation</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>Are you sure you want to delete this student?</Modal.Body>
//                 <Modal.Footer>
//                     <Button style={{ backgroundColor: 'grey', color: 'white' }} onClick={handleClose}>
//                         Cancel
//                     </Button>
//                     <Button style={{ backgroundColor: 'red', color: 'white', marginLeft: '10px' }} onClick={() => handleConfirm(deletingStudentId)}>
//                         Confirm
//                     </Button>
//                 </Modal.Footer>
//             </Modal>
//         );
//     };


//     const openDetailsModal = (student, isEdit) => {
//         setEditedStudent(student);
//         setIsReadOnly(!isEdit);
//         setEditModalOpen(true);
//     };

//     const handleDelete = (id) => {
//         setDeletingStudentId(id);
//         setShowDeleteModal(true);
//     };

//     const handleCloseDeleteModal = () => {
//         setShowDeleteModal(false);
//     };

//     const handleConfirmDelete = async (id) => {
//         try {
//             // Send the PUT request to change the student's status
//             await axios.delete(`/registrationadvances/${id}`);

//             // Update the students state by filtering out the deleted student
//             const updatedStudents = students.filter((student) => student.id !== id);
//             setStudents(updatedStudents);
//             setFilteredStudents(updatedStudents);

//             // Show success message
//             toast.success('Student deleted successfully');
//         } catch (error) {
//             console.error('Error deleting student:', error);
//             // Handle error scenarios (e.g., showing an error message)
//             toast.error('Failed to delete student. Please try again.');
//         } finally {
//             handleCloseDeleteModal();
//         }
//     };



//     const openEditModal = (student) => {
//         setEditedStudent(student);
//         setEditModalOpen(true);
//     };


//     const closeEditModal = () => {
//         setEditModalOpen(false);
//     };



//     const uploadFile = async (file, folderPath) => {
//         const timestamp = Date.now();
//         const fileExtension = file.name.split(".").pop();
//         const fileNameWithTimestamp = `${timestamp}.${fileExtension}`;

//         const formData = new FormData();
//         formData.append("file", file, fileNameWithTimestamp);
//         formData.append("upload_preset", CLOUDINARY_UPLOAD);
//         formData.append("public_id", `${folderPath}/${fileNameWithTimestamp}`);

//         const response = await fetch(CLOUDINARY_URL, {
//             method: "POST",
//             body: formData,
//         });

//         const data = await response.json();
//         return data.secure_url || ""; // Return the uploaded file's URL
//     };

//     const handleSaveEdit = async (e) => {
//         e.preventDefault();

//         try {
//             // Validate fields
//             const requiredFields = ['name', 'email', 'phone', 'nric', 'address', 'passport', 'passportExpiryDate', 'citizenship', 'gender']; // Add all required field keys here
//             const emptyFields = requiredFields.filter(
//                 (field) => !editedStudent[field] || editedStudent[field].trim() === ''
//             );

//             if (emptyFields.length > 0) {
//                 toast.error(`The following fields are required: ${emptyFields.join(', ')}`, {
//                     position: "top-right",
//                     autoClose: 5000,
//                     hideProgressBar: false,
//                     closeOnClick: true,
//                     pauseOnHover: true,
//                     draggable: true,
//                     progress: undefined,
//                 });
//                 return;
//             }


//             const highestCount = editedStudent.institutionDetails?.filter(inst => inst.highest).length || 0;
//             if (highestCount !== 1) {
//                 toast.error("Please select exactly one institution as 'Highest qualification'");
//                 return;
//             }

//             const confirmation = window.confirm(
//                 "Are you sure you want to update this student?"
//             );
//             if (!confirmation) {
//                 return;
//             }

//             // Existing URLs
//             let profileUrl = editedStudent.profileUrl;
//             let nricdoc = editedStudent.nricdoc;
//             let passportdoc = editedStudent.passportdoc;
//             let educationdoc = editedStudent.educationdoc;

//             // Upload files if selected
//             if (selectedProfileFile) {
//                 profileUrl = await uploadFile(
//                     selectedProfileFile,
//                     "LMS/Student/Profile"
//                 );
//             }
//             if (selectedNricFile) {
//                 nricdoc = await uploadFile(selectedNricFile, "LMS/Student/Nric");
//             }
//             if (selectedPassportFile) {
//                 passportdoc = await uploadFile(
//                     selectedPassportFile,
//                     "LMS/Student/Passport"
//                 );
//             }
//             if (selectedEducationFile) {
//                 educationdoc = await uploadFile(
//                     selectedEducationFile,
//                     "LMS/Student/Education"
//                 );
//             }

//             const updatedStudent = {
//                 ...editedStudent,
//                 profileUrl,
//                 nricdoc,
//                 passportdoc,
//                 educationdoc,
//             };

//             const response = await axios.put(
//                 `registrationadvances/${editedStudent.id}`,
//                 updatedStudent
//             );

//             if (response.status === 200) {
//                 const updatedStudents = students.map((student) =>
//                     student.id === editedStudent.id ? updatedStudent : student
//                 );
//                 setStudents(updatedStudents);
//                 closeEditModal();
//                 toast.success("Student updated successfully", {
//                     position: "top-right",
//                     autoClose: 3000,
//                     hideProgressBar: false,
//                     closeOnClick: true,
//                     pauseOnHover: true,
//                     draggable: true,
//                     progress: undefined,
//                 });
//             } else {
//                 console.error("Failed to update student");
//                 toast.error("Failed to update student", {
//                     position: "top-right",
//                     autoClose: 3000,
//                     hideProgressBar: false,
//                     closeOnClick: true,
//                     pauseOnHover: true,
//                     draggable: true,
//                     progress: undefined,
//                 });
//             }
//         } catch (error) {
//             console.error("Error updating student:", error);
//             toast.error("An error occurred while updating the student", {
//                 position: "top-right",
//                 autoClose: 3000,
//                 hideProgressBar: false,
//                 closeOnClick: true,
//                 pauseOnHover: true,
//                 draggable: true,
//                 progress: undefined,
//             });
//         }
//     };





//     const handleBulkDownload = () => {
//         const formatDate = (dateString) => {
//             if (!dateString) return '';
//             const date = new Date(dateString);
//             const day = String(date.getDate()).padStart(2, '0');
//             const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
//                 "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
//             const month = monthNames[date.getMonth()];
//             const year = date.getFullYear();
//             return `${day} ${month} ${year}`;
//         };

//         const filteredData = filteredStudents.map(student => ({
//             Name: student.name,
//             Nric: student.nric,
//             Email: student.email,
//             Phone: student.phone,
//             Gender: student.gender,
//             Dob: formatDate(student.dob),
//             Password: student.password,
//             Officephone: student.officephone,
//             Address: student.address,
//             Course: student.course,
//             Citizenship: student.citizenship,
//             Passport: student.passport,
//             PassportExpiryDate: formatDate(student.passportExpiryDate),
//             CurrentAddress: student.currentAddress,
//             Religion: student.religion,
//             ProfileUrl: student.profileUrl,
//             Nricdoc: student.nricdoc,
//             Educationdoc: student.educationdoc,
//             Passportdoc: student.passportdoc,
//             InstitutionDetails: student.institutionDetails.map(inst =>
//                 `${inst.institution} (From: ${formatDate(inst.fromYear)}, To: ${formatDate(inst.toYear)}, Language: ${inst.language}, Qualification: ${inst.qualificationsAchieved})`
//             ).join('; '),
//             WorkExperiences: student.workExpirences.map(exp =>
//                 `${exp.name} (Position: ${exp.position}, From: ${formatDate(exp.fromYear)}, To: ${formatDate(exp.toYear)}, Duties: ${exp.natureOfPosition},Country: ${exp.country})`
//             ).join('; '),
//             EmergencyContacts: student.emergencyContacts.map(contact =>
//                 `${contact.name} (Number: ${contact.number}, Relationship: ${contact.relationship}, Others: ${contact.othersRelationship})`
//             ).join('; ')
//         }));
//         // Create Excel workbook and sheet
//         const workbook = XLSX.utils.book_new();
//         const worksheet = XLSX.utils.json_to_sheet(filteredData);
//         XLSX.utils.book_append_sheet(workbook, worksheet, 'Students');
//         // Auto-width for columns
//         const columnWidths = Object.keys(filteredData[0] || {}).map(key => ({
//             wch: Math.max(
//                 key.length,
//                 ...filteredData.map(row => (row[key]?.toString().length || 10))
//             ) + 2
//         }));
//         worksheet['!cols'] = columnWidths;
//         // Generate and download Excel file
//         const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
//         const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
//         const url = URL.createObjectURL(blob);
//         const link = document.createElement('a');
//         link.href = url;
//         link.setAttribute('download', 'students.xlsx');
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//     };



//     const [isFocused, setIsFocused] = useState(false);

//     const handleEmergencyChange = (index, field, value) => {
//         const updatedContacts = [...editedStudent.emergencyContacts];
//         updatedContacts[index][field] = value;
//         setEditedStudent({ ...editedStudent, emergencyContacts: updatedContacts });
//     };

//     const handleAddEmergency = () => {
//         setEditedStudent({
//             ...editedStudent,
//             emergencyContacts: [
//                 ...editedStudent.emergencyContacts,
//                 { name: '', number: '', relationship: '', othersRelationship: '' },
//             ],
//         });
//     };

//     const handleRemoveEmergency = (index) => {
//         const updatedContacts = [...editedStudent.emergencyContacts];
//         updatedContacts.splice(index, 1);
//         setEditedStudent({ ...editedStudent, emergencyContacts: updatedContacts });
//     };

//     const handleInstitutionChange = (index, e) => {
//         const { name, value } = e.target;
//         const newInstitutionDetails = editedStudent.institutionDetails.map((institution, i) => {
//             if (i === index) {
//                 return { ...institution, [name]: value };
//             }
//             return institution;
//         });
//         setEditedStudent({ ...editedStudent, institutionDetails: newInstitutionDetails });
//     };

//     const handleAddEducation = () => {
//         setEditedStudent({
//             ...editedStudent,
//             institutionDetails: [
//                 ...editedStudent.institutionDetails,
//                 { institution: '', fromYear: '', toYear: '', qualificationsAchieved: '', highest: false, language: '' },
//             ],
//         });
//     };

//     const handleRemoveEducation = (index) => {
//         const newInstitutionDetails = editedStudent.institutionDetails.filter((_, i) => i !== index);
//         setEditedStudent({ ...editedStudent, institutionDetails: newInstitutionDetails });
//     };


//     const handleWorkExperienceChange = (index, e) => {
//         const { name, value } = e.target;
//         const newWorkExperiences = editedStudent.workExpirences.map((experience, i) => {
//             if (i === index) {
//                 return { ...experience, [name]: value };
//             }
//             return experience;
//         });
//         setEditedStudent({
//             ...editedStudent,
//             workExpirences: newWorkExperiences
//         });
//     };

//     const handleAddWorkExperience = () => {
//         setEditedStudent((prevState) => ({
//             ...prevState,
//             workExpirences: [
//                 ...prevState.workExpirences,
//                 { name: '', position: '', fromYear: '', toYear: '', country: '', natureOfPosition: '' }
//             ]
//         }));
//         setShowEmploymentFields(true); // Show employment fields after adding
//     };

//     const handleRemoveWorkExperience = (index) => {
//         const newWorkExperiences = editedStudent.workExpirences.filter((_, i) => i !== index);
//         setEditedStudent({
//             ...editedStudent,
//             workExpirences: newWorkExperiences
//         });
//         if (newWorkExperiences.length === 0) {
//             setShowEmploymentFields(false); // Hide employment fields if no experience entries
//         }
//     };


//     const handlePdfEditcertificate = async (student) => {
//         console.log(student)
//         const pdfBytes = await fetch(Invitation).then((res) => res.arrayBuffer());
//         const pdfDoc = await PDFDocument.load(pdfBytes);
//         const pages = pdfDoc.getPages();
//         const firstPage = pages[0];
//         // const secondPage = pages[1];
//         const fontSize = 12;

//         const TimesRomanBoldFont = await pdfDoc.embedFont(StandardFonts.TimesRomanBold);
//         const TimesRoman = await pdfDoc.embedFont(StandardFonts.TimesRoman);

//         const passport = student.passport || ' ';
//         const studentName = student.name || ' ';
//         const course = student.course || ' ';

//         // const currentDate = new Date().toISOString();
//         const currentDate = student.offerDate;

//         const wrapText = (text, maxWidth) => {
//             const words = text.split(" ");
//             let lines = [];
//             let currentLine = words[0];

//             for (let i = 1; i < words.length; i++) {
//                 const word = words[i];
//                 const width = TimesRoman.widthOfTextAtSize(`${currentLine} ${word}`, fontSize);

//                 if (width < maxWidth) {
//                     currentLine += ` ${word}`;
//                 } else {
//                     lines.push(currentLine);
//                     currentLine = word;
//                 }
//             }
//             lines.push(currentLine);
//             return lines;
//         };
//         const maxWidth = 460;
//         const wrappedText = wrapText(
//             `I am pleased to inform you that you have been admitted to Charisma University ${course}! Your student ID is ${passport} and your login information has been e-mailed to you.`,
//             maxWidth
//         );

//         let yPosition = 522;  // Initial y position
//         const lineSpacing = 15; // Adjust this value to reduce line spacing

//         const formatDate = (dateString) => {
//             const date = new Date(dateString);
//             const day = String(date.getDate()).padStart(2, '0');
//             const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
//             const year = date.getFullYear();
//             return `${day}.${month}.${year}`;
//         };

//         // Draw each line with reduced line spacing
//         wrappedText.forEach((line) => {
//             firstPage.drawText(line, {
//                 x: 73,
//                 y: yPosition,
//                 size: fontSize,
//                 font: TimesRoman,
//                 color: rgb(0, 0.1216, 0.3725),
//             });
//             yPosition -= lineSpacing; // Adjust y position for the next line
//         });

//         firstPage.drawText(`${studentName},`, { x: 99, y: 545.5, size: 12, font: TimesRoman, color: rgb(0, 0.1216, 0.3725), });
//         firstPage.drawText(`${formatDate(currentDate)}`, { x: 480, y: 595.5, size: 12, font: TimesRoman, color: rgb(0, 0.1216, 0.3725), });


//         const pdfBytesModified = await pdfDoc.save();
//         const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
//         const pdfUrl = URL.createObjectURL(pdfBlob);
//         window.open(pdfUrl, '_blank');
//     }

//     const handleViewStudent = async (student) => {


//         // try {
//         //     // First API call
//         //     const response = await axios.get(`/student/${student.id}`);
//         const courseFees = student.courseFees && student.courseFees.length > 0 ? student.courseFees : [];
//         setPaymentDetails(courseFees);
//         setSelectedStudent(student);
//         setShowModal(true);

//         // } catch (error) {
//         //     console.error('Error fetching student details:', error);
//         // }
//     };

//     const handleCloseModal = () => {
//         setShowModal(false);

//     };


//     const formatDate = (dateString) => {
//         const date = new Date(dateString);
//         const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with leading zero if necessary
//         const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1 and pad
//         const year = date.getFullYear(); // Get full year

//         return `${day}/${month}/${year}`;
//     };

//     const numberToWords = (number) => {
//         const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
//         const teens = ['', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
//         const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
//         const suffixes = ['', 'Thousand'];


//         const numToWords = (num) => {
//             let words = '';
//             if (num >= 1000) {
//                 words += numToWords(Math.floor(num / 1000)) + ' Thousand ';
//                 num %= 1000;
//             }
//             if (num >= 100) {
//                 words += ones[Math.floor(num / 100)] + ' Hundred ';
//                 num %= 100;
//             }
//             if (num >= 20) {
//                 words += tens[Math.floor(num / 10)] + ' ';
//                 num %= 10;
//             }
//             if (num > 0) {
//                 if (num >= 11 && num <= 19) {
//                     words += teens[num - 10] + ' ';
//                 } else {
//                     words += ones[num] + ' ';
//                 }
//             }
//             return words.trim();
//         };

//         if (number === 0) return 'Zero';
//         return numToWords(number);
//     };

//     const handledownloadReciept = async (selectedStudent, student) => {
//         console.log("gfg:", student)
//         const pdfBytes = await fetch(courserecipt).then((res) => res.arrayBuffer());
//         const pdfDoc = await PDFDocument.load(pdfBytes);
//         pdfDoc.registerFontkit(fontkit);
//         const pages = pdfDoc.getPages();
//         const firstPage = pages[0];
//         // const courierfont = await pdfDoc.embedFont(StandardFonts.Courier);
//         //const courierfontbold = await pdfDoc.embedFont(StandardFonts.CourierBold);
//         const calibriFontBoldBytes = await fetch(TimesRoman).then((res) => res.arrayBuffer());
//         const courierfont = await pdfDoc.embedFont(calibriFontBoldBytes);

//         const amountText = student?.amount ? `$${(student.amount).toFixed(2)}` : ''; // Ensure the dollar symbol is always present
//         const type = student?.feestype;
//         let label = '';
//         let labelX = 318;
//         if (type === 'Registration fee') {
//             label = 'Registration Fees';
//             labelX = 317;
//         } else if (type === 'Course fee') {
//             label = 'Course Fees';
//             labelX = 335;
//         } else {
//             label = '';
//         }
//         const balanceToDisplay = student?.feestype === 'Course fee'
//             ? student?.courseFeebalance?.toFixed(2)
//             : student?.registrationFeebalance?.toFixed(2);
//         const sumOfDollars = numberToWords(student?.amount);
//         // Convert numbers to strings
//         firstPage.drawText(String(student?.studentName || '').toUpperCase(), { x: 128, y: 572, size: 10, font: courierfont, color: rgb(0, 0, 0) });
//         firstPage.drawText(String(student?.finNric || ''), { x: 128, y: 558, size: 10, font: courierfont, color: rgb(0, 0, 0) });
//         firstPage.drawText(String(selectedStudent?.studentIds || ''), { x: 133, y: 545, size: 10, font: courierfont, color: rgb(0, 0, 0) });
//         firstPage.drawText(String(selectedStudent?.email || ''), { x: 115, y: 504, size: 10, font: courierfont, color: rgb(0, 0, 0) });
//         function wrapText(text, font, fontSize, maxWidth) {
//             const words = text.split(' ');
//             const lines = [];
//             let currentLine = '';
//             for (let i = 0; i < words.length; i++) {
//                 const word = words[i];
//                 const testLine = currentLine ? currentLine + ' ' + word : word;
//                 const textWidth = font.widthOfTextAtSize(testLine, fontSize);
//                 if (textWidth <= maxWidth) {
//                     currentLine = testLine;
//                 } else {
//                     if (currentLine) lines.push(currentLine);
//                     currentLine = word;
//                 }
//             }
//             if (currentLine) lines.push(currentLine);
//             return lines;
//         }
//         // 3. Apply it in PDF-lib drawing
//         const rawCourseName = student?.course || '';
//         const cleanedCourseName = removeBracketedText(rawCourseName);
//         const maxWidth = 150;
//         const fontSize = 10;
//         const startX = 128;
//         let startY = 531;
//         const lines = wrapText(cleanedCourseName, courierfont, fontSize, maxWidth);
//         lines.forEach((line) => {
//             firstPage.drawText(line, {
//                 x: startX,
//                 y: startY,
//                 size: fontSize,
//                 font: courierfont,
//                 color: rgb(0, 0, 0),
//             });
//             startY -= fontSize + 2; // Move down for the next line
//         });
//         // firstPage.drawText(String(feeDetail?.description || ''), { x: 35, y: 520, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
//         firstPage.drawText(String(student?.invoiceNumber || ''), { x: 467, y: 569, size: 12, font: courierfont, color: rgb(0, 0, 0) });
//         firstPage.drawText(String(formatDate(student?.date || '')), { x: 477, y: 466, size: 10, font: courierfont, color: rgb(0, 0, 0) });
//         firstPage.drawText(amountText, { x: 485, y: 384, size: 10, font: courierfont, color: rgb(0, 0, 0) });
//         firstPage.drawText(amountText, { x: 485, y: 319, size: 10, font: courierfont, color: rgb(0, 0, 0) });
//         firstPage.drawText(label, { x: labelX, y: 371, size: 10, font: courierfont, color: rgb(0, 0, 0) });
//         firstPage.drawText(String(formatDate(student?.date || '')), { x: 85, y: 384, size: 10, font: courierfont, color: rgb(0, 0, 0) });
//         // firstPage.drawText(amountText, { x: 497, y: 460, size: 10, font: courierfont, color: rgb(0, 0, 0) });
//         // firstPage.drawText(`${sumOfDollars} Dollars Only`, { x: 177, y: 464, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
//         // firstPage.drawText("AUD", { x: 498, y: 438, size: 1, font: courierfont, color: rgb(0, 0, 0) });
//         firstPage.drawText(`S$${balanceToDisplay}`, { x: 483, y: 291, size: 10, font: courierfont, color: rgb(0, 0, 0) });
//         // const drawWrappedText = async (page, text, x, y, font, fontSize, maxWidth) => {
//         //     text = replaceTabs(text);
//         //     const lines = [];
//         //     let currentLine = '';
//         //     const words = text.split(' ');
//         //     for (let i = 0; i < words.length; i++) {
//         //         const word = words[i];
//         //         const width = getTextWidth(currentLine + ' ' + word, font, fontSize);
//         //         if (width < maxWidth) {
//         //             currentLine += (currentLine === '' ? '' : ' ') + word;
//         //         } else {
//         //             lines.push(currentLine.trim());
//         //             currentLine = word;
//         //         }
//         //     }
//         //     if (currentLine !== '') {
//         //         lines.push(currentLine.trim());
//         //     }
//         //     for (let i = 0; i < lines.length; i++) {
//         //         const line = lines[i].trim();
//         //         const lineWidth = getTextWidth(line, font, fontSize);
//         //         await page.drawText(line, {
//         //             x: i === 0 ? x : x,
//         //             y: y - i * 12,
//         //             size: fontSize,
//         //             font,
//         //             color: rgb(0, 0, 0),
//         //         });
//         //     }
//         // };
//         // function replaceTabs(text) {
//         //     return text.replace(/\t/g, '    '); // Replace each tab with four spaces
//         // }
//         // const getTextWidth = (text, font, fontSize) => {
//         //     const width = font.widthOfTextAtSize(text, fontSize);
//         //     return width;
//         // };
//         // let yPosition = 520;
//         // const lineHeight = 10;
//         // drawWrappedText(firstPage, String(feeDetail?.description || ''), 77, yPosition, courierfontbold, 10, 380);
//         // yPosition -= lineHeight;
//         // drawWrappedText(firstPage, `${sumOfDollars} Dollars Only`, 177, 464, courierfontbold, 10, 300);
//         const pdfBytesModified = await pdfDoc.save();
//         const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
//         const pdfUrl = URL.createObjectURL(pdfBlob);
//         window.open(pdfUrl, '_blank');
//     };

//     return (
//         <div>
//             <div className="container" style={{ maxWidth: '1400px' }}>
//                 {loading ? (
//                     <Loader />
//                 ) : (
//                     <Paper sx={{ width: '100%', overflow: 'hidden' }}>

//                         <Grid container spacing={2} alignItems="center" marginTop={'5px'} padding={' 7px 5px '}>
//                             {/* Search Input */}
//                             <Grid item xs={12} sm={4}>
//                                 <TextField
//                                     fullWidth
//                                     variant="outlined"
//                                     label="Search by Name"
//                                     value={searchQuery}
//                                     onChange={handleSearch}
//                                     InputProps={{ style: { borderRadius: '8px' } }}
//                                 />
//                             </Grid>
//                             {/* Gender Filter Dropdown */}
//                             <Grid item xs={12} sm={4}>
//                                 <FormControl fullWidth variant="outlined">
//                                     <InputLabel>Filter by Gender</InputLabel>
//                                     <Select
//                                         value={filterGender}
//                                         onChange={(e) => setFilterGender(e.target.value)}
//                                         label="Filter by Gender"
//                                         style={{ borderRadius: '8px' }}
//                                     >
//                                         <MenuItem value="">All</MenuItem>
//                                         <MenuItem value="Male">Male</MenuItem>
//                                         <MenuItem value="Female">Female</MenuItem>
//                                     </Select>
//                                 </FormControl>
//                             </Grid>
//                             {/* Bulk Download Button */}
//                             <Grid item xs={12} sm={4}>
//                                 <Button
//                                     variant="contained"
//                                     color="primary"
//                                     fullWidth
//                                     onClick={handleBulkDownload}
//                                     style={{
//                                         textTransform: 'capitalize',
//                                         borderRadius: '8px',
//                                         padding: '15px 15px',
//                                         fontWeight: 'bold',
//                                     }}
//                                 >
//                                     Bulk Download
//                                 </Button>
//                             </Grid>
//                         </Grid>
//                         <br />
//                         <TableContainer
//                             sx={{
//                                 overflowX: 'auto',
//                                 maxWidth: '100%',
//                                 '@media (min-width: 768px)': { // Apply styles for screens smaller than 768px (mobile)
//                                     overflowX: 'unset', // Enable horizontal scroll
//                                 },
//                             }}
//                         >
//                             <div style={{ maxHeight: '600px', overflowY: 'auto' }}>

//                                 <Table aria-label="sticky table">
//                                     <TableHead style={{ backgroundColor: 'black', position: 'sticky', top: 0, zIndex: 1 }}>
//                                         <TableRow>
//                                             {columns.map((column) => (
//                                                 <TableCell
//                                                     key={column.id}
//                                                     align="left"
//                                                     style={{ fontWeight: 'bold' }}
//                                                 >
//                                                     {column.label}
//                                                 </TableCell>
//                                             ))}
//                                         </TableRow>
//                                     </TableHead>
//                                     <TableBody>
//                                         {filteredStudents
//                                             .slice((currentPage - 1) * studentsPerPage, currentPage * studentsPerPage)
//                                             .map((student, index) => (
//                                                 <TableRow key={student.id}>
//                                                     <TableCell>{index + 1}</TableCell>
//                                                     <TableCell>
//                                                         <span

//                                                             title={`${student.name} details`}

//                                                             style={{ cursor: 'pointer', textDecoration: 'underline', color: 'blue' }}
//                                                             onClick={() => openDetailsModal(student, false)} // Pass 'false' for read-only mode
//                                                         >
//                                                             {student.name}
//                                                         </span>
//                                                     </TableCell>
//                                                     {/* <TableCell>
//                                                         <img
//                                                             src={student.profileUrl ? student.profileUrl :
//                                                                 student.gender === 'Male' ?
//                                                                     'https://uxwing.com/wp-content/themes/uxwing/download/peoples-avatars/default-profile-picture-male-icon.png' :
//                                                                     student.gender === 'Female' ?
//                                                                         'https://cdn3.iconfinder.com/data/icons/business-vol-26/100/Artboard_2-512.png' :
//                                                                         'https://static.vecteezy.com/system/resources/thumbnails/002/318/271/small/user-profile-icon-free-vector.jpg'}
//                                                             alt="Profile"
//                                                             style={{ width: '150px', height: '100px' }}
//                                                         />
//                                                     </TableCell> */}
//                                                     <TableCell>{student.nric}</TableCell>
//                                                     {/* <TableCell>
//                                                         {student.nric
//                                                             ? "*".repeat(student.nric.length - 4) + student.nric.slice(-4)
//                                                             : "N/A"}
//                                                     </TableCell> */}

//                                                     <TableCell>{student.email}</TableCell>
//                                                     <TableCell>{student.phone}</TableCell>
//                                                     <TableCell>{student.gender}</TableCell>
//                                                     <TableCell>
//                                                         {student.offerDate ?
//                                                             (() => {
//                                                                 const date = new Date(student.offerDate);
//                                                                 const day = String(date.getDate()).padStart(2, '0');
//                                                                 const month = String(date.getMonth() + 1).padStart(2, '0');
//                                                                 const year = date.getFullYear();
//                                                                 return `${day}-${month}-${year}`;
//                                                             })()
//                                                             : ''
//                                                         }
//                                                     </TableCell>
//                                                     <TableCell style={{ width: '10%' }}>
//                                                         <div style={{ display: 'flex', alignItems: 'center' }}>
//                                                             <BsPencilFill
//                                                                 style={{ marginRight: 10 }}
//                                                                 onClick={() => openDetailsModal(student, true)} // Pass 'true' for edit mode
//                                                             />                    <DeleteRoundedIcon
//                                                                 style={{ color: 'red', marginLeft: 10 }}
//                                                                 onClick={() => handleDelete(student.id)}
//                                                             />

//                                                         </div>
//                                                     </TableCell>
//                                                     {/* <TableCell><ApplicationForm ref={applicationFormRef} />
//                                                         <Button
//                                                             variant="contained"
//                                                             color="primary"
//                                                             onClick={() => handleApplicationForm(student)} // Calls the function from ApplicationForm
//                                                         > Application
//                                                         </Button>
//                                                     </TableCell> */}
//                                                     {/* <TableCell>
//                                                         <OfferLetter ref={offerLetterRef} />
//                                                         <Button
//                                                             variant="contained"
//                                                             color="primary"
//                                                             onClick={() => handleOfferForm(student)}
//                                                         >
//                                                             offer
//                                                         </Button>
//                                                     </TableCell>
//                                                     <TableCell>
//                                                         <Button
//                                                             variant="contained"
//                                                             color="primary"
//                                                             // style={{ marginBottom: '10px', width: '45%', maxWidth: '180px' }}
//                                                             // startIcon={<FontAwesomeIcon icon={faGraduationCap} />}
//                                                             onClick={() => handlePdfEditcertificate(student)}
//                                                         >
//                                                             Invitation
//                                                         </Button>
//                                                     </TableCell> */}
//                                                     <TableCell>
//                                                         <Button variant="contained" onClick={() => handleViewStudent(student)}>
//                                                             View
//                                                         </Button>

//                                                     </TableCell>
//                                                 </TableRow>
//                                             ))}
//                                     </TableBody>
//                                 </Table>
//                             </div>
//                         </TableContainer>
//                         <TablePagination
//                             rowsPerPageOptions={[10, 25, 100]}
//                             component="div"
//                             count={filteredStudents.length}
//                             rowsPerPage={studentsPerPage}
//                             page={currentPage - 1}
//                             labelDisplayedRows={({ from, to }) => `${from}-${to} Page No ${currentPage}`}
//                             onPageChange={(event, newPage) => setCurrentPage(newPage + 1)}
//                             onRowsPerPageChange={(event) => {
//                                 setCurrentPage(1);
//                                 setStudentsPerPage(event.target.value);
//                             }}
//                         />
//                     </Paper>
//                 )}
//             </div>

//             <Modal
//                 show={showModal}
//                 onHide={handleCloseModal}
//                 size="lg"
//                 aria-labelledby="contained-modal-title-vcenter"
//                 centered
//                 fullscreen
//             >
//                 <Modal.Header closeButton>
//                     {/* <Modal.Title>Student Details</Modal.Title> */}
//                     {/* <Button onClick={handleDownloadPDF} variant="contained" color="primary">Download PDF</Button> */}
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div id="modalContent">
//                         {paymentDetails && paymentDetails.length > 0 ? (
//                             <>
//                                 <Grid item xs={10} md={6}>
//                                     <Paper elevation={3} style={{ padding: '24px', height: '100%' }}>
//                                         <Typography variant="h6" gutterBottom style={{ fontWeight: 'bolder' }}>Payment Details</Typography>
//                                         <TableContainer>
//                                             <Grid item xs={12} md={6}>
//                                                 <Paper elevation={3} style={{ padding: '24px', height: '100%' }}>
//                                                     <div >
//                                                         <div>
//                                                             <Typography variant="h6" component="div" gutterBottom>
//                                                                 Course Fee Details
//                                                             </Typography>
//                                                             <TableContainer component={Paper}>
//                                                                 <Table aria-label="Registration fee details table">
//                                                                     <TableHead>
//                                                                         <TableRow>
//                                                                             <TableCell>Invoice Number</TableCell>
//                                                                             <TableCell>Date</TableCell>
//                                                                             <TableCell>Amount Paid</TableCell>
//                                                                             <TableCell>Discount</TableCell>
//                                                                             <TableCell>Description</TableCell>
//                                                                             <TableCell>Action</TableCell>


//                                                                             {/* <TableCell>Fee Type</TableCell> */}
//                                                                         </TableRow>
//                                                                     </TableHead>
//                                                                     <TableBody>
//                                                                         {paymentDetails.filter(feeDetail => feeDetail.feestype === "Course fee").length > 0 ? (
//                                                                             paymentDetails
//                                                                                 .filter(feeDetail => feeDetail.feestype === "Course fee")
//                                                                                 .map((feeDetail, index) => (
//                                                                                     <TableRow key={index}>
//                                                                                         <TableCell>{feeDetail.invoiceNumber}</TableCell>
//                                                                                         <TableCell>{formatDate(feeDetail.date)}</TableCell>
//                                                                                         <TableCell>${feeDetail.amount}</TableCell>
//                                                                                         <TableCell>{feeDetail.discount ? `$${feeDetail.discount}` : "NA"}</TableCell>
//                                                                                         <TableCell>{feeDetail.description}</TableCell>
//                                                                                         <TableCell>
//                                                                                             <Button
//                                                                                                 variant="contained"
//                                                                                                 color="primary"
//                                                                                                 onClick={() => handledownloadReciept(selectedStudent, feeDetail)}
//                                                                                             >
//                                                                                                 View Receipt
//                                                                                             </Button>
//                                                                                         </TableCell>
//                                                                                     </TableRow>
//                                                                                 ))
//                                                                         ) : (
//                                                                             <TableRow>
//                                                                                 <TableCell colSpan={6} align="center">
//                                                                                     No data available
//                                                                                 </TableCell>
//                                                                             </TableRow>
//                                                                         )}
//                                                                     </TableBody>
//                                                                 </Table>
//                                                             </TableContainer>

//                                                             <Typography variant="h6" component="div" gutterBottom style={{ marginTop: '20px' }}>
//                                                                 Registration Fee Details
//                                                             </Typography>
//                                                             <TableContainer component={Paper}>
//                                                                 <Table aria-label="Course Fee table">
//                                                                     <TableHead>
//                                                                         <TableRow>
//                                                                             <TableCell style={{ fontWeight: 'bold' }}>Invoice Number</TableCell>
//                                                                             <TableCell style={{ fontWeight: 'bold' }}>Date</TableCell>
//                                                                             <TableCell style={{ fontWeight: 'bold' }}>Amount Paid</TableCell>
//                                                                             <TableCell style={{ fontWeight: 'bold' }}>Description</TableCell>
//                                                                             <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
//                                                                         </TableRow>
//                                                                     </TableHead>
//                                                                     <TableBody>
//                                                                         {paymentDetails.filter(feeDetail => feeDetail.feestype === "Registration fee").length > 0 ? (
//                                                                             paymentDetails
//                                                                                 .filter(feeDetail => feeDetail.feestype === "Registration fee")
//                                                                                 .map((feeDetail, index) => (
//                                                                                     <TableRow key={index}>
//                                                                                         <TableCell>{feeDetail.invoiceNumber}</TableCell>
//                                                                                         <TableCell>{formatDate(feeDetail.date)}</TableCell>
//                                                                                         <TableCell>${feeDetail.amount}</TableCell>
//                                                                                         <TableCell>{feeDetail.description}</TableCell>
//                                                                                         <TableCell>
//                                                                                             <Button
//                                                                                                 variant="contained"
//                                                                                                 color="primary"
//                                                                                                 onClick={() => handledownloadReciept(selectedStudent, feeDetail)}
//                                                                                             >
//                                                                                                 View Receipt
//                                                                                             </Button>
//                                                                                         </TableCell>
//                                                                                     </TableRow>
//                                                                                 ))
//                                                                         ) : (
//                                                                             <TableRow>
//                                                                                 <TableCell colSpan={5} align="center">
//                                                                                     No data available
//                                                                                 </TableCell>
//                                                                             </TableRow>
//                                                                         )}
//                                                                     </TableBody>

//                                                                 </Table>
//                                                             </TableContainer>
//                                                         </div>
//                                                     </div>

//                                                     {/* <div style={{ marginTop: '20px' }}>
//                             <App ref={childRef} dataProp={dataForprop} />
//                             <Button variant="contained" color="primary" onClick={handleContractletter}>Student Contract</Button>
//                             <span style={{ marginRight: '10px' }}></span>
//                             <AdmissionOffer ref={admissionOfferRef} dataProp={dataForprop} />
//                             <Button variant="contained" color="primary" onClick={handleOfferletter}>Offer Letter</Button>
//                             <span style={{ marginRight: '10px' }}></span>
//                             <ApplicationForm ref={applicationFormRef} dataProp={dataForprop} studentInfo={studentInfo} />
//                             <Button variant="contained" color="primary" onClick={handleApplicationForm}>Application Form</Button>
//                           </div> */}
//                                                 </Paper>
//                                             </Grid>

//                                         </TableContainer>
//                                     </Paper>
//                                 </Grid>

//                             </>
//                         ) : (
//                             <Typography variant="h6" style={{ textAlign: 'center', margin: '20px' }}>
//                                 No payment details available for this student.
//                             </Typography>
//                         )}
//                     </div>


//                 </Modal.Body>
//             </Modal>


//             <Dialog open={isEditModalOpen} onClose={closeEditModal}>
//                 <DialogTitle>
//                     {isReadOnly ? 'Student Details' : 'Edit Student (Newton International College)'}
//                 </DialogTitle>
//                 <DialogContent>
//                     <form onSubmit={handleSaveEdit}>
//                         <Grid container spacing={3}>
//                             {/* Personal Information Section */}
//                             <Grid item xs={12}>
//                                 <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
//                                     Personal Information
//                                 </Typography>
//                             </Grid>

//                             <Grid item xs={12} md={6}>
//                                 <TextField
//                                     label="Full Name"
//                                     name="fullname"
//                                     required
//                                     fullWidth
//                                     value={editedStudent?.name || ''}
//                                     onChange={(e) => {
//                                         if (!isReadOnly) {
//                                             const inputValue = e.target.value.replace(/[^A-Za-z\s]/g, '');
//                                             const truncatedValue = inputValue.substring(0, 25);
//                                             if (truncatedValue.trim() !== '' || truncatedValue.length === 0) {
//                                                 setEditedStudent({
//                                                     ...editedStudent,
//                                                     name: truncatedValue,
//                                                 });
//                                             }
//                                         }
//                                     }}
//                                     margin="normal"
//                                     InputProps={{ readOnly: isReadOnly }}
//                                 />
//                             </Grid>

//                             <Grid item xs={12} md={6}>
//                                 <TextField
//                                     label="NRIC/FIN No*"
//                                     name="nric"
//                                     fullWidth
//                                     value={editedStudent?.nric || ''}
//                                     onChange={(e) => {
//                                         if (!isReadOnly) {
//                                             const inputValue = e.target.value.replace(/[^A-Za-z0-9]/g, '').substring(0, 9);
//                                             setEditedStudent({
//                                                 ...editedStudent,
//                                                 nric: inputValue,
//                                             });
//                                         }
//                                     }}
//                                     margin="normal"
//                                     InputProps={{ readOnly: isReadOnly }}
//                                 />
//                             </Grid>

//                             <Grid item xs={12} md={6}>
//                                 <TextField
//                                     label="Email*"
//                                     name="email"
//                                     type="email"
//                                     fullWidth
//                                     value={editedStudent?.email || ''}
//                                     onChange={(e) => {
//                                         if (!isReadOnly) {
//                                             setEditedStudent({
//                                                 ...editedStudent,
//                                                 email: e.target.value,
//                                             });
//                                         }
//                                     }}
//                                     margin="normal"
//                                     InputProps={{ readOnly: isReadOnly }}
//                                 />
//                             </Grid>

//                             <Grid item xs={12} md={6}>
//                                 <TextField
//                                     label="Course Fee*"
//                                     name="courseFee"
//                                     type="number"
//                                     fullWidth
//                                     value={editedStudent?.courseFee || ''}
//                                     onChange={(e) => {
//                                         if (!isReadOnly) {
//                                             setEditedStudent({
//                                                 ...editedStudent,
//                                                 courseFee: e.target.value,
//                                             });
//                                         }
//                                     }}
//                                     margin="normal"
//                                     InputProps={{
//                                         readOnly: isReadOnly,
//                                         startAdornment: <InputAdornment position="start">$</InputAdornment>
//                                     }}
//                                 />
//                             </Grid>

//                             <Grid item xs={12} md={6}>
//                                 <TextField
//                                     label="Passport*"
//                                     name="passport"
//                                     fullWidth
//                                     value={editedStudent?.passport || ''}
//                                     onChange={(e) => {
//                                         if (!isReadOnly) {
//                                             setEditedStudent({
//                                                 ...editedStudent,
//                                                 passport: e.target.value,
//                                             });
//                                         }
//                                     }}
//                                     margin="normal"
//                                     InputProps={{ readOnly: isReadOnly }}
//                                 />
//                             </Grid>

//                             <Grid item xs={12} md={6}>
//                                 <TextField
//                                     type="date"
//                                     label="Passport Expiry Date*"
//                                     name="passportexpiredate"
//                                     fullWidth
//                                     value={editedStudent?.passportExpiryDate || ''}
//                                     onChange={(e) => {
//                                         if (!isReadOnly) {
//                                             setEditedStudent({
//                                                 ...editedStudent,
//                                                 passportExpiryDate: e.target.value,
//                                             });
//                                         }
//                                     }}
//                                     margin="normal"
//                                     InputLabelProps={{ shrink: true }}
//                                     InputProps={{ readOnly: isReadOnly }}
//                                 />
//                             </Grid>

//                             <Grid item xs={12} md={6}>
//                                 <TextField
//                                     label="Citizenship*"
//                                     name="citizenship"
//                                     fullWidth
//                                     value={editedStudent?.citizenship || ''}
//                                     onChange={(e) => {
//                                         if (!isReadOnly) {
//                                             setEditedStudent({
//                                                 ...editedStudent,
//                                                 citizenship: e.target.value,
//                                             });
//                                         }
//                                     }}
//                                     margin="normal"
//                                     InputProps={{ readOnly: isReadOnly }}
//                                 />
//                             </Grid>

//                             <Grid item xs={12} md={6}>
//                                 <TextField
//                                     type="date"
//                                     label="Documents Date*"
//                                     name="offerDate"
//                                     fullWidth
//                                     value={editedStudent?.offerDate || ''}
//                                     onChange={(e) => {
//                                         if (!isReadOnly) {
//                                             setEditedStudent({
//                                                 ...editedStudent,
//                                                 offerDate: e.target.value,
//                                             });
//                                         }
//                                     }}
//                                     margin="normal"
//                                     InputLabelProps={{ shrink: true }}
//                                     InputProps={{ readOnly: isReadOnly }}
//                                 />
//                             </Grid>

//                             <Grid item xs={12} md={6}>
//                                 <TextField
//                                     label="Course*"
//                                     name="course"
//                                     fullWidth
//                                     value={editedStudent?.course || ''}
//                                     margin="normal"
//                                     InputProps={{ readOnly: true }}
//                                 />
//                             </Grid>

//                             <Grid item xs={12} md={6}>
//                                 <FormControl fullWidth margin="normal" disabled={isReadOnly}>
//                                     <InputLabel id="gender-label">Gender*</InputLabel>
//                                     <Select
//                                         labelId="gender-label"
//                                         id="gender"
//                                         value={editedStudent?.gender || ''}
//                                         onChange={(e) => {
//                                             if (!isReadOnly) {
//                                                 setEditedStudent({
//                                                     ...editedStudent,
//                                                     gender: e.target.value,
//                                                 });
//                                             }
//                                         }}
//                                         label="Gender*"
//                                     >
//                                         <MenuItem value="">Select Gender</MenuItem>
//                                         <MenuItem value="Male">Male</MenuItem>
//                                         <MenuItem value="Female">Female</MenuItem>
//                                         <MenuItem value="Other">Other</MenuItem>
//                                     </Select>
//                                 </FormControl>
//                             </Grid>

//                             <Grid item xs={12} md={6}>
//                                 <TextField
//                                     label="Date of Birth*"
//                                     type="date"
//                                     name="dob"
//                                     fullWidth
//                                     value={editedStudent?.dob || '2000-01-01'}
//                                     onChange={(e) => {
//                                         if (!isReadOnly) {
//                                             setEditedStudent({
//                                                 ...editedStudent,
//                                                 dob: e.target.value,
//                                             });
//                                         }
//                                     }}
//                                     margin="normal"
//                                     InputLabelProps={{ shrink: true }}
//                                     inputProps={{
//                                         min: '1920-01-01',
//                                         max: '2012-12-31',
//                                         readOnly: isReadOnly,
//                                     }}
//                                     disabled={isReadOnly}
//                                 />
//                             </Grid>

//                             {/* Contact Information Section */}
//                             <Grid item xs={12} mt={3}>
//                                 <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
//                                     Contact Information
//                                 </Typography>
//                             </Grid>

//                             <Grid item xs={12} md={6}>
//                                 <TextField
//                                     label="Home Phone*"
//                                     name="phone"
//                                     fullWidth
//                                     value={editedStudent?.phone || ''}
//                                     onChange={(e) => {
//                                         if (!isReadOnly) {
//                                             const inputValue = e.target.value.replace(/[^0-9]/g, '').substring(0, 10);
//                                             setEditedStudent({
//                                                 ...editedStudent,
//                                                 phone: inputValue,
//                                             });
//                                         }
//                                     }}
//                                     margin="normal"
//                                     InputProps={{ readOnly: isReadOnly }}
//                                 />
//                             </Grid>

//                             <Grid item xs={12} md={6}>
//                                 <TextField
//                                     label="Office Phone"
//                                     name="officephone"
//                                     fullWidth
//                                     value={editedStudent?.officephone || ''}
//                                     onChange={(e) => {
//                                         if (!isReadOnly) {
//                                             const inputValue = e.target.value.replace(/[^0-9]/g, '').substring(0, 10);
//                                             setEditedStudent({
//                                                 ...editedStudent,
//                                                 officephone: inputValue,
//                                             });
//                                         }
//                                     }}
//                                     margin="normal"
//                                     InputProps={{ readOnly: isReadOnly }}
//                                 />
//                             </Grid>

//                             {/* <Grid item xs={12} md={6}>
//                                 <TextField
//                                     label="Password*"
//                                     name="password"
//                                     type={showPassword ? 'text' : 'password'}
//                                     fullWidth
//                                     value={editedStudent?.password || ''}
//                                     onChange={(e) => {
//                                         if (!isReadOnly) {
//                                             setEditedStudent({
//                                                 ...editedStudent,
//                                                 password: e.target.value,
//                                             });
//                                         }
//                                     }}
//                                     margin="normal"
//                                     InputProps={{
//                                         readOnly: isReadOnly,
//                                         endAdornment: (
//                                             <InputAdornment position="end">
//                                                 <IconButton
//                                                     onClick={togglePasswordVisibility}
//                                                     edge="end"
//                                                     disabled={isReadOnly}
//                                                 >
//                                                     {showPassword ? <VisibilityOff /> : <Visibility />}
//                                                 </IconButton>
//                                             </InputAdornment>
//                                         ),
//                                     }}
//                                 />
//                             </Grid> */}

//                             {/* Address Information Section */}
//                             <Grid item xs={12} mt={3}>
//                                 <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
//                                     Address Information
//                                 </Typography>
//                             </Grid>

//                             <Grid item xs={12} md={6}>
//                                 <TextField
//                                     label="Home Address*"
//                                     name="address"
//                                     fullWidth
//                                     value={editedStudent?.address || ''}
//                                     onChange={(e) => {
//                                         if (!isReadOnly) {
//                                             setEditedStudent({
//                                                 ...editedStudent,
//                                                 address: e.target.value,
//                                             });
//                                         }
//                                     }}
//                                     margin="normal"
//                                     InputProps={{ readOnly: isReadOnly }}
//                                 />
//                             </Grid>

//                             <Grid item xs={12} md={6}>
//                                 <TextField
//                                     label="Singapore Address"
//                                     name="currentAddress"
//                                     fullWidth
//                                     value={editedStudent?.currentAddress || ''}
//                                     onChange={(e) => {
//                                         if (!isReadOnly) {
//                                             setEditedStudent({
//                                                 ...editedStudent,
//                                                 currentAddress: e.target.value,
//                                             });
//                                         }
//                                     }}
//                                     margin="normal"
//                                     InputProps={{ readOnly: isReadOnly }}
//                                 />
//                             </Grid>

//                             <Grid item xs={12} md={6}>
//                                 <TextField
//                                     label="Postal Code*"
//                                     name="postalcode"
//                                     fullWidth
//                                     value={editedStudent?.postalcode || ''}
//                                     onChange={(e) => {
//                                         if (!isReadOnly) {
//                                             const inputValue = e.target.value.replace(/[^0-9]/g, '').substring(0, 6);
//                                             setEditedStudent({
//                                                 ...editedStudent,
//                                                 postalcode: inputValue,
//                                             });
//                                         }
//                                     }}
//                                     margin="normal"
//                                     InputProps={{ readOnly: isReadOnly }}
//                                 />
//                             </Grid>

//                             <Grid item xs={12} md={6}>
//                                 <TextField
//                                     label="Religion*"
//                                     name="religion"
//                                     fullWidth
//                                     value={editedStudent?.religion || ''}
//                                     onChange={(e) => {
//                                         if (!isReadOnly) {
//                                             setEditedStudent({
//                                                 ...editedStudent,
//                                                 religion: e.target.value,
//                                             });
//                                         }
//                                     }}
//                                     margin="normal"
//                                     InputProps={{ readOnly: isReadOnly }}
//                                 />
//                             </Grid>

//                             <Grid item xs={12} md={6}>
//                                 <TextField
//                                     label="Sign Date"
//                                     type="date"
//                                     name="signDate"
//                                     fullWidth
//                                     value={editedStudent?.signDate || ''}
//                                     onChange={(e) => {
//                                         if (!isReadOnly) {
//                                             setEditedStudent({
//                                                 ...editedStudent,
//                                                 signDate: e.target.value,
//                                             });
//                                         }
//                                     }}
//                                     margin="normal"
//                                     InputLabelProps={{ shrink: true }}
//                                     InputProps={{ readOnly: isReadOnly }}
//                                 />
//                             </Grid>

//                             {/* Document Upload Section */}
//                             <Grid item xs={12} mt={3}>
//                                 <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
//                                     Document Uploads
//                                 </Typography>
//                             </Grid>

//                             <Grid item xs={12} md={6}>
//                                 <Typography variant="subtitle1">Upload photo</Typography>
//                                 <TextField
//                                     type="file"
//                                     id="profileUpload"
//                                     fullWidth
//                                     accept="image/png, image/jpeg, image/jpg"
//                                     onChange={(e) => {
//                                         const file = e.target.files[0];
//                                         if (!file) return;
//                                         const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
//                                         if (file.size > 8 * 1024 * 1024) {
//                                             e.target.value = "";
//                                             toast.error("File size must be less than 8MB.");
//                                         } else if (!allowedTypes.includes(file.type)) {
//                                             e.target.value = "";
//                                             toast.error("Invalid file type. Only PNG, JPG, or JPEG are allowed.");
//                                         } else {
//                                             setSelectedProfileFile(file);
//                                         }
//                                     }}
//                                     variant="outlined"
//                                     style={{ marginTop: '8px' }}
//                                     disabled={isReadOnly}
//                                 />
//                                 {editedStudent?.profileUrl && (
//                                     <Button
//                                         variant="contained"
//                                         color="primary"
//                                         href={editedStudent.profileUrl}
//                                         target="_blank"
//                                         rel="noopener noreferrer"
//                                         style={{ marginTop: '8px', color: 'white' }}
//                                     >
//                                         View
//                                     </Button>
//                                 )}
//                             </Grid>

//                             <Grid item xs={12} md={6}>
//                                 <Typography variant="subtitle1">Upload NRIC</Typography>
//                                 <TextField
//                                     type="file"
//                                     id="nricUpload"
//                                     fullWidth
//                                     accept="application/pdf"
//                                     onChange={(e) => {
//                                         const file = e.target.files[0];
//                                         if (!file) return;
//                                         const allowedTypes = ['application/pdf'];
//                                         if (file.size > 8 * 1024 * 1024) {
//                                             e.target.value = "";
//                                             toast.error("File size must be less than 8MB.");
//                                         } else if (!allowedTypes.includes(file.type)) {
//                                             e.target.value = "";
//                                             toast.error("Invalid file type. Only PDF files are allowed.");
//                                         } else {
//                                             setSelectedNricFile(file);
//                                         }
//                                     }}
//                                     variant="outlined"
//                                     style={{ marginTop: '8px' }}
//                                     disabled={isReadOnly}
//                                 />
//                                 {editedStudent?.nricdoc && (
//                                     <Button
//                                         variant="contained"
//                                         color="primary"
//                                         href={editedStudent.nricdoc}
//                                         target="_blank"
//                                         rel="noopener noreferrer"
//                                         style={{ marginTop: '8px', color: 'white' }}
//                                     >
//                                         View NRIC Document
//                                     </Button>
//                                 )}
//                             </Grid>

//                             <Grid item xs={12} md={6}>
//                                 <Typography variant="subtitle1">Upload Passport</Typography>
//                                 <TextField
//                                     type="file"
//                                     id="passportUpload"
//                                     accept="application/pdf"
//                                     fullWidth
//                                     onChange={(e) => {
//                                         const file = e.target.files[0];
//                                         if (!file) return;
//                                         const allowedTypes = ['application/pdf'];
//                                         if (file.size > 8 * 1024 * 1024) {
//                                             e.target.value = "";
//                                             toast.error("File size must be less than 8MB.");
//                                         } else if (!allowedTypes.includes(file.type)) {
//                                             e.target.value = "";
//                                             toast.error("Invalid file type. Only PDF files are allowed.");
//                                         } else {
//                                             setSelectedPassportFile(file);
//                                         }
//                                     }}
//                                     variant="outlined"
//                                     style={{ marginTop: '8px' }}
//                                     disabled={isReadOnly}
//                                 />
//                                 {editedStudent?.passportdoc && (
//                                     <Button
//                                         variant="contained"
//                                         color="primary"
//                                         href={editedStudent.passportdoc}
//                                         target="_blank"
//                                         rel="noopener noreferrer"
//                                         style={{ marginTop: '8px', color: 'white' }}
//                                     >
//                                         View Passport Document
//                                     </Button>
//                                 )}
//                             </Grid>

//                             <Grid item xs={12} md={6}>
//                                 <Typography variant="subtitle1">Upload Education Document</Typography>
//                                 <TextField
//                                     type="file"
//                                     id="educationUpload"
//                                     fullWidth
//                                     accept="application/pdf"
//                                     onChange={(e) => {
//                                         const file = e.target.files[0];
//                                         if (!file) return;
//                                         const allowedTypes = ['application/pdf'];
//                                         if (file.size > 8 * 1024 * 1024) {
//                                             e.target.value = "";
//                                             toast.error("File size must be less than 8MB.");
//                                         } else if (!allowedTypes.includes(file.type)) {
//                                             e.target.value = "";
//                                             toast.error("Invalid file type. Only PDF files are allowed.");
//                                         } else {
//                                             setSelectedEducationFile(file);
//                                         }
//                                     }}
//                                     variant="outlined"
//                                     style={{ marginTop: '8px' }}
//                                     disabled={isReadOnly}
//                                 />
//                                 {editedStudent?.educationdoc && (
//                                     <Button
//                                         variant="contained"
//                                         color="primary"
//                                         href={editedStudent.educationdoc}
//                                         target="_blank"
//                                         rel="noopener noreferrer"
//                                         style={{ marginTop: '8px', color: 'white' }}
//                                     >
//                                         View Education Document
//                                     </Button>
//                                 )}
//                             </Grid>

//                             {/* Educational Details Section */}
//                             <Grid item xs={12} mt={3}>
//                                 <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
//                                     Educational Details
//                                 </Typography>
//                             </Grid>

//                             {editedStudent.institutionDetails?.map((institution, index) => (
//                                 <Grid item xs={12} key={index}>
//                                     <Card variant="outlined" sx={{ p: 2, mb: 2 }}>
//                                         <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//                                             <Checkbox
//                                                 id={`highest-${index}`}
//                                                 checked={!!institution.highest}
//                                                 onChange={(e) => {
//                                                     const updatedInstitutions = editedStudent.institutionDetails.map((inst, i) => ({
//                                                         ...inst,
//                                                         highest: i === index ? e.target.checked : false, // Only one can be true
//                                                     }));
//                                                     setEditedStudent({ ...editedStudent, institutionDetails: updatedInstitutions });
//                                                 }}
//                                                 disabled={isReadOnly}
//                                             />
//                                             <label htmlFor={`highest-${index}`}>Mark as Highest Qualification</label>
//                                         </Box>

//                                         <Grid container spacing={2}>
//                                             <Grid item xs={12} md={6}>
//                                                 <TextField
//                                                     fullWidth
//                                                     label="Institution Name"
//                                                     name="institution"
//                                                     value={institution.institution}
//                                                     onChange={(e) => handleInstitutionChange(index, e)}
//                                                     InputProps={{ readOnly: isReadOnly }}
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={6}>
//                                                 <TextField
//                                                     fullWidth
//                                                     label="Degree"
//                                                     name="qualificationsAchieved"
//                                                     value={institution.qualificationsAchieved}
//                                                     onChange={(e) => handleInstitutionChange(index, e)}
//                                                     InputProps={{ readOnly: isReadOnly }}
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={6}>
//                                                 <TextField
//                                                     fullWidth
//                                                     label="Country"
//                                                     name="country"
//                                                     value={institution.country}
//                                                     onChange={(e) => handleInstitutionChange(index, e)}
//                                                     InputProps={{ readOnly: isReadOnly }}
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={6}>
//                                                 <TextField
//                                                     fullWidth
//                                                     label="From Year"
//                                                     name="fromYear"
//                                                     value={institution.fromYear}
//                                                     onChange={(e) => handleInstitutionChange(index, e)}
//                                                     InputProps={{ readOnly: isReadOnly }}
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={6}>
//                                                 <TextField
//                                                     fullWidth
//                                                     label="To Year"
//                                                     name="toYear"
//                                                     value={institution.toYear}
//                                                     onChange={(e) => handleInstitutionChange(index, e)}
//                                                     InputProps={{ readOnly: isReadOnly }}
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={6}>
//                                                 <TextField
//                                                     fullWidth
//                                                     label="Language of Instruction"
//                                                     name="language"
//                                                     value={institution.language}
//                                                     onChange={(e) => handleInstitutionChange(index, e)}
//                                                     InputProps={{ readOnly: isReadOnly }}
//                                                 />
//                                             </Grid>
//                                         </Grid>

//                                         {!isReadOnly && (
//                                             <Button
//                                                 variant="outlined"
//                                                 color="error"
//                                                 onClick={() => handleRemoveEducation(index)}
//                                                 startIcon={<DeleteIcon />}
//                                                 sx={{ mt: 2 }}
//                                             >
//                                                 Remove Education
//                                             </Button>
//                                         )}
//                                     </Card>
//                                 </Grid>
//                             ))}

//                             {!isReadOnly && (
//                                 <Grid item xs={12}>
//                                     <Button
//                                         variant="contained"
//                                         onClick={handleAddEducation}
//                                         startIcon={<AddIcon />}
//                                     >
//                                         Add Education
//                                     </Button>
//                                 </Grid>
//                             )}

//                             {/* Work Experience Section */}
//                             <Grid item xs={12} mt={3}>
//                                 <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
//                                     Work Experience
//                                 </Typography>
//                             </Grid>

//                             {editedStudent.workExpirences?.map((experience, index) => (
//                                 <Grid item xs={12} key={index}>
//                                     <Card variant="outlined" sx={{ p: 2, mb: 2 }}>
//                                         <Grid container spacing={2}>
//                                             <Grid item xs={12} md={6}>
//                                                 <TextField
//                                                     fullWidth
//                                                     label="Company Name"
//                                                     name="name"
//                                                     value={experience.name}
//                                                     onChange={(e) => handleWorkExperienceChange(index, e)}
//                                                     InputProps={{ readOnly: isReadOnly }}
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={6}>
//                                                 <TextField
//                                                     fullWidth
//                                                     label="Position"
//                                                     name="position"
//                                                     value={experience.position}
//                                                     onChange={(e) => handleWorkExperienceChange(index, e)}
//                                                     InputProps={{ readOnly: isReadOnly }}
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={6}>
//                                                 <TextField
//                                                     type="number"
//                                                     label="From Year"
//                                                     name="fromYear"
//                                                     value={experience.fromYear}
//                                                     onChange={(e) => handleWorkExperienceChange(index, e)}
//                                                     fullWidth
//                                                     InputProps={{ readOnly: isReadOnly }}
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={6}>
//                                                 <TextField
//                                                     type="number"
//                                                     label="To Year"
//                                                     name="toYear"
//                                                     value={experience.toYear}
//                                                     onChange={(e) => handleWorkExperienceChange(index, e)}
//                                                     fullWidth
//                                                     InputProps={{ readOnly: isReadOnly }}
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12}>
//                                                 <TextField
//                                                     label="Nature of Duties"
//                                                     name="natureOfPosition"
//                                                     value={experience.natureOfPosition}
//                                                     onChange={(e) => handleWorkExperienceChange(index, e)}
//                                                     fullWidth
//                                                     InputProps={{ readOnly: isReadOnly }}
//                                                 />
//                                             </Grid>
//                                         </Grid>

//                                         {!isReadOnly && (
//                                             <Button
//                                                 variant="outlined"
//                                                 color="error"
//                                                 onClick={() => handleRemoveWorkExperience(index)}
//                                                 startIcon={<DeleteIcon />}
//                                                 sx={{ mt: 2 }}
//                                             >
//                                                 Remove Experience
//                                             </Button>
//                                         )}
//                                     </Card>
//                                 </Grid>
//                             ))}

//                             {!isReadOnly && (
//                                 <Grid item xs={12}>
//                                     <Button
//                                         variant="contained"
//                                         onClick={handleAddWorkExperience}
//                                         startIcon={<AddIcon />}
//                                     >
//                                         Add Work Experience
//                                     </Button>
//                                 </Grid>
//                             )}

//                             {/* Emergency Contacts Section */}
//                             <Grid item xs={12} mt={3}>
//                                 <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
//                                     Emergency Contacts
//                                 </Typography>
//                             </Grid>

//                             {editedStudent.emergencyContacts?.map((contact, index) => (
//                                 <Grid item xs={12} key={index}>
//                                     <Card variant="outlined" sx={{ p: 2, mb: 2 }}>
//                                         <Grid container spacing={2}>
//                                             <Grid item xs={12} md={6}>
//                                                 <FormControl fullWidth>
//                                                     <InputLabel>Relationship</InputLabel>
//                                                     <Select
//                                                         value={contact.relationship}
//                                                         onChange={(e) => handleEmergencyChange(index, 'relationship', e.target.value)}
//                                                         label="Relationship"
//                                                         disabled={isReadOnly}
//                                                     >
//                                                         <MenuItem value="">-- Select Relationship --</MenuItem>
//                                                         <MenuItem value="Father">Father</MenuItem>
//                                                         <MenuItem value="Mother">Mother</MenuItem>
//                                                         <MenuItem value="Brother">Brother</MenuItem>
//                                                         <MenuItem value="Sister">Sister</MenuItem>
//                                                         <MenuItem value="Others">Others</MenuItem>
//                                                     </Select>
//                                                 </FormControl>
//                                             </Grid>

//                                             {contact.relationship === 'Others' && (
//                                                 <Grid item xs={12} md={6}>
//                                                     <TextField
//                                                         label="Relationship with Applicant"
//                                                         value={contact.othersRelationship}
//                                                         onChange={(e) => handleEmergencyChange(index, 'othersRelationship', e.target.value)}
//                                                         fullWidth
//                                                         InputProps={{ readOnly: isReadOnly }}
//                                                     />
//                                                 </Grid>
//                                             )}

//                                             <Grid item xs={12} md={6}>
//                                                 <TextField
//                                                     label="Name"
//                                                     value={contact.name}
//                                                     onChange={(e) => handleEmergencyChange(index, 'name', e.target.value)}
//                                                     fullWidth
//                                                     InputProps={{ readOnly: isReadOnly }}
//                                                 />
//                                             </Grid>

//                                             <Grid item xs={12} md={6}>
//                                                 <TextField
//                                                     label="Contact No"
//                                                     value={contact.number}
//                                                     onChange={(e) => handleEmergencyChange(index, 'number', e.target.value)}
//                                                     inputProps={{ maxLength: 10 }}
//                                                     fullWidth
//                                                     InputProps={{ readOnly: isReadOnly }}
//                                                 />
//                                             </Grid>
//                                         </Grid>

//                                         {!isReadOnly && (
//                                             <Button
//                                                 variant="outlined"
//                                                 color="error"
//                                                 onClick={() => handleRemoveEmergency(index)}
//                                                 startIcon={<DeleteIcon />}
//                                                 sx={{ mt: 2, float: 'right' }}
//                                             >
//                                                 Remove Contact
//                                             </Button>
//                                         )}
//                                     </Card>
//                                 </Grid>
//                             ))}

//                             {!isReadOnly && (
//                                 <Grid item xs={12}>
//                                     <Button
//                                         variant="contained"
//                                         onClick={handleAddEmergency}
//                                         startIcon={<AddIcon />}
//                                     >
//                                         Add Emergency Contact
//                                     </Button>
//                                 </Grid>
//                             )}


//                         </Grid>
//                     </form>
//                 </DialogContent>
//                 <DialogActions>
//                     {!isReadOnly && ( // Conditionally render the Update button based on read-only mode
//                         <Button onClick={handleSaveEdit} variant="contained" color="primary" style={{ backgroundColor: 'green', color: 'white' }}>
//                             Update
//                         </Button>
//                     )}
//                     <Button onClick={closeEditModal} variant="contained" color="secondary" style={{ backgroundColor: 'red', color: 'white' }}>
//                         Close
//                     </Button>
//                 </DialogActions>
//             </Dialog>
//             <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar />
//             <DeleteConfirmationModal
//                 show={showDeleteModal}
//                 handleClose={handleCloseDeleteModal}
//                 handleConfirm={handleConfirmDelete}
//             />
//         </div >
//     );
// };


// const New = () => {
//     const [tabValue, setTabValue] = useState(0);

//     const handleChange = (event, newValue) => {
//         setTabValue(newValue);
//     };



//     const handleTabChange = (newValue) => {
//         setTabValue(newValue);
//     };

//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//     return (
//         <div>
//             <Header />
//             <br />
//             <div className="d-flex justify-content-center mt-4">
//                 <Tabs
//                     value={tabValue}
//                     onChange={handleChange}
//                     aria-label="Students-tabs"
//                     variant="fullWidth"
//                     sx={{
//                         borderRadius: 10,
//                         display: 'flex',
//                         justifyContent: 'center',
//                         "& button": {
//                             borderRadius: 10,
//                             color: "#555",

//                             margin: 'auto',
//                             display: 'block'
//                         },
//                         "& button:hover": {
//                             backgroundColor: "#eee",
//                         },
//                         "& button:active": {
//                             backgroundColor: "#ddd",
//                         },
//                         "& button.Mui-selected": {
//                             backgroundColor: "#007bff",
//                             color: "#fff",
//                         },
//                         "& .MuiTabs-indicator": {
//                             display: 'none', // Remove the underline
//                         },
//                         ...(isMobile && {
//                             flexDirection: 'column', // Stack tabs vertically
//                             "& button": {
//                                 width: '100%', // Set tabs to full width on mobile
//                             },
//                         }),
//                     }}
//                 >
//                     <Tab label="All Students" sx={{ minWidth: isMobile ? '50%' : '620px' }} />
//                     <Tab label="New Student" sx={{ minWidth: isMobile ? '50%' : '620px' }} />
//                 </Tabs>
//             </div>
//             <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
//                 {tabValue === 0 && <Screen />}
//                 {tabValue === 1 && <Newstudent onFormSubmit={() => handleTabChange(0)} />}
//             </div>
//             {/* <div
//         style={{
//           position: 'absolute',
//           bottom: '30px', // Adjust to desired distance from the bottom
//           right: '30px', // Adjust to desired distance from the right
//           opacity: 0.5, // Transparency for the image
//           zIndex: 1, // Ensure it is below other UI elements
//           pointerEvents: 'none',
//         }}
//       >
//         <img
//          src={Charisma}
//           alt="Charisma"
//           style={{
//             maxWidth: '120px', // Adjust the size as needed
//             maxHeight: '120px',
//           }}
//         />
//       </div> */}
//         </div>
//     );



// };

// export default New;

import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios, { removeBracketedText } from '../Axiosinstance';
import TimesRoman from '../fonts/times.ttf'
import { StudentDetailsModal } from '../Batchescourserun/Manage';
import Charisma from '.././images/Charisma.png'
import {
    TextField,
    Button, IconButton,
    Grid,
    Typography,
    Container,
    Paper,
    Box,
    Dialog,
    DialogActions,
    InputAdornment,
    Checkbox,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Card,
    Tooltip,
    LinearProgress, Slide, CircularProgress
} from '@mui/material'
import { Visibility, VisibilityOff } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import TablePagination from '@mui/material/TablePagination';
import Header from '../components/Header';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { BsPencilFill, BsTrashFill } from 'react-icons/bs';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import * as XLSX from 'xlsx';
import { toast, ToastContainer } from 'react-toastify';
import { CLOUDINARY_UPLOAD_PRESET, baseURL } from '../common'
import Newstudent from './Newstudent'
import Loader from '../Loader';
import Modal from 'react-bootstrap/Modal';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import ApplicationForm from './ApplicationForm';
import OfferLetter from '../components/OfferLetter.jsx';
import Invitation from '../pdf/Invitation.pdf'
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import icon from '../All/images/tick-icon.png';
// import icon from '../All/images/tick-icon.png';
// import fs from 'fs';
import fontkit from '@pdf-lib/fontkit';  // Import fontkit for custom fonts
import poppins from '../fonts/Poppins-Regular.ttf';
import poppinsBold from '../fonts/Poppins-Bold.ttf';
import courserecipt from '../pdf/courserecipt.pdf'


const columns = [
    { id: 'S.NO', label: 'S.NO', minWidth: 170 },
    { id: 'name', label: 'Name', minWidth: 170 },
    { id: 'studentIds', label: 'Student ID', minWidth: 170 },
    { id: 'NRIC/FIN No', label: 'NRIC/FIN No', minWidth: 170 },
    { id: 'email', label: 'Email', minWidth: 170 },
    { id: 'phone', label: 'Phone', minWidth: 170 },
    { id: 'gender', label: 'Gender', minWidth: 170 },
    { id: 'Documents Date', label: 'Documents Date', minWidth: 170 },
    { id: 'actions', label: 'Actions', minWidth: 170 },
    { id: 'Documents', label: 'Documents', minWidth: 170 },
    // { id: 'OfferLetter', label: 'Offer Letter', minWidth: 170 },
    // { id: 'Invitation', label: 'Invitation', minWidth: 170 },
    { id: 'Reciept', label: 'Reciept', minWidth: 170 },
];


const Screen = () => {
    const [students, setStudents] = useState([]);
    const [filteredStudents, setFilteredStudents] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [studentsPerPage, setStudentsPerPage] = useState(100);
    const [searchQuery, setSearchQuery] = useState('');
    const [filterGender, setFilterGender] = useState('');
    const [isEditModalOpen, setEditModalOpen] = useState(false);
    const [editedStudent, setEditedStudent] = useState({});
    const [pageSize, setPageSize] = useState(10);
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(true);
    const CLOUDINARY_URL = baseURL;
    const CLOUDINARY_UPLOAD = CLOUDINARY_UPLOAD_PRESET;
    const [uploadedImageUrl, setUploadedImageUrl] = useState('');
    const [isReadOnly, setIsReadOnly] = useState(true);
    const [dataForprop, setDataForprop] = useState(null);
    const [showEmploymentFields, setShowEmploymentFields] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [paymentDetails, setPaymentDetails] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState(null);
const [showProfileModal, setShowProfileModal] = useState(false);
const [profileStudentData, setProfileStudentData] = useState(null);
const [profileLoading, setProfileLoading] = useState(false);


    const applicationFormRef = useRef(null);
    const offerLetterRef = useRef(null)


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setSelectedFile(file);
    };
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        fetchStudents();
    }, []);


    const [selectedProfileFile, setSelectedProfileFile] = useState(null);
    const [selectedNricFile, setSelectedNricFile] = useState(null);
    const [selectedPassportFile, setSelectedPassportFile] = useState(null);
    const [selectedEducationFile, setSelectedEducationFile] = useState(null);

    useEffect(() => {
        if (editedStudent) {
            setSelectedProfileFile(null);
            setSelectedNricFile(null);
            setSelectedPassportFile(null);
            setSelectedEducationFile(null);
        }
    }, [editedStudent]);

    const fetchStudents = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                "registrationadvances/registration/status?status=Active"
            );
            setStudents(response.data.reverse());
            setLoading(false);
        } catch (error) {
            console.error("Error fetching students:", error);
            setLoading(false);
        }
    };



    const handleApplicationForm = (student) => {
        if (applicationFormRef.current) {
            applicationFormRef.current.handleDownload(student); // Call handlePdfEdit function of the child component
        }
    };

    const handleOfferForm = (student) => {
        if (offerLetterRef.current) {
            offerLetterRef.current.handleDownload(student); // Call handlePdfEdit function of the child component
        }
    };

    useEffect(() => {
        const filtered = students.filter((student) => {
            if (filterGender) {
                return student.gender.toLowerCase() === filterGender.toLowerCase();
            }
            return true;
        });


        const searchFiltered = filtered.filter((student) =>
            student.name.toLowerCase().includes(searchQuery.toLowerCase())
        );


        setFilteredStudents(searchFiltered);
    }, [searchQuery, filterGender, students, currentPage, pageSize]);


    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1); // Reset to the first page when searching
    };

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const handleFilterGender = (gender) => {
        setFilterGender(gender);
        setCurrentPage(1); // Reset to the first page when applying filters
    };

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deletingStudentId, setDeletingStudentId] = useState(null);

    const DeleteConfirmationModal = ({ show, handleClose, handleConfirm }) => {
        return (
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this student?</Modal.Body>
                <Modal.Footer>
                    <Button style={{ backgroundColor: 'grey', color: 'white' }} onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button style={{ backgroundColor: 'red', color: 'white', marginLeft: '10px' }} onClick={() => handleConfirm(deletingStudentId)}>
                        Confirm
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };


    // const openDetailsModal = (student, isEdit) => {
    //     setEditedStudent(student);
    //     setIsReadOnly(!isEdit);
    //     setEditModalOpen(true);
    // };

    const openDetailsModal = async (student, isEdit) => {
  if (!isEdit) {
    // View mode → use the modern StudentDetailsModal
    try {
      setProfileLoading(true);
      setShowProfileModal(true);
      const response = await axios.get(`/registrationadvances/${student.id}`);
      setProfileStudentData(response.data);
    } catch (err) {
      console.error('Error fetching student data:', err);
    } finally {
      setProfileLoading(false);
    }
  } else {
    // Edit mode → keep existing dialog
    setEditedStudent(student);
    setIsReadOnly(false);
    setEditModalOpen(true);
  }
};

    const handleDelete = (id) => {
        setDeletingStudentId(id);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };

    const handleConfirmDelete = async (id) => {
        try {
            // Send the PUT request to change the student's status
            await axios.delete(`/registrationadvances/${id}`);

            // Update the students state by filtering out the deleted student
            const updatedStudents = students.filter((student) => student.id !== id);
            setStudents(updatedStudents);
            setFilteredStudents(updatedStudents);

            // Show success message
            toast.success('Student deleted successfully');
        } catch (error) {
            console.error('Error deleting student:', error);
            // Handle error scenarios (e.g., showing an error message)
            toast.error('Failed to delete student. Please try again.');
        } finally {
            handleCloseDeleteModal();
        }
    };



    const openEditModal = (student) => {
        setEditedStudent(student);
        setEditModalOpen(true);
    };


    const closeEditModal = () => {
        setEditModalOpen(false);
    };



    const uploadFile = async (file, folderPath) => {
        const timestamp = Date.now();
        const fileExtension = file.name.split(".").pop();
        const fileNameWithTimestamp = `${timestamp}.${fileExtension}`;

        const formData = new FormData();
        formData.append("file", file, fileNameWithTimestamp);
        formData.append("upload_preset", CLOUDINARY_UPLOAD);
        formData.append("public_id", `${folderPath}/${fileNameWithTimestamp}`);

        const response = await fetch(CLOUDINARY_URL, {
            method: "POST",
            body: formData,
        });

        const data = await response.json();
        return data.secure_url || ""; // Return the uploaded file's URL
    };

    const handleSaveEdit = async (e) => {
        e.preventDefault();

        try {
            // Validate fields
            const requiredFields = ['name', 'email', 'phone', 'nric', 'address', 'passport', 'passportExpiryDate', 'citizenship', 'gender']; // Add all required field keys here
            const emptyFields = requiredFields.filter(
                (field) => !editedStudent[field] || editedStudent[field].trim() === ''
            );

            if (emptyFields.length > 0) {
                toast.error(`The following fields are required: ${emptyFields.join(', ')}`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            }


            const highestCount = editedStudent.institutionDetails?.filter(inst => inst.highest).length || 0;
            if (highestCount !== 1) {
                toast.error("Please select exactly one institution as 'Highest qualification'");
                return;
            }

            const confirmation = window.confirm(
                "Are you sure you want to update this student?"
            );
            if (!confirmation) {
                return;
            }

            // Existing URLs
            let profileUrl = editedStudent.profileUrl;
            let nricdoc = editedStudent.nricdoc;
            let passportdoc = editedStudent.passportdoc;
            let educationdoc = editedStudent.educationdoc;

            // Upload files if selected
            if (selectedProfileFile) {
                profileUrl = await uploadFile(
                    selectedProfileFile,
                    "LMS/Student/Profile"
                );
            }
            if (selectedNricFile) {
                nricdoc = await uploadFile(selectedNricFile, "LMS/Student/Nric");
            }
            if (selectedPassportFile) {
                passportdoc = await uploadFile(
                    selectedPassportFile,
                    "LMS/Student/Passport"
                );
            }
            if (selectedEducationFile) {
                educationdoc = await uploadFile(
                    selectedEducationFile,
                    "LMS/Student/Education"
                );
            }

            const updatedStudent = {
                ...editedStudent,
                profileUrl,
                nricdoc,
                passportdoc,
                educationdoc,
            };

            const response = await axios.put(
                `registrationadvances/${editedStudent.id}`,
                updatedStudent
            );

            if (response.status === 200) {
                const updatedStudents = students.map((student) =>
                    student.id === editedStudent.id ? updatedStudent : student
                );
                setStudents(updatedStudents);
                closeEditModal();
                toast.success("Student updated successfully", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                console.error("Failed to update student");
                toast.error("Failed to update student", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } catch (error) {
            console.error("Error updating student:", error);
            toast.error("An error occurred while updating the student", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };





    const handleBulkDownload = () => {
        const formatDate = (dateString) => {
            if (!dateString) return '';
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            const month = monthNames[date.getMonth()];
            const year = date.getFullYear();
            return `${day} ${month} ${year}`;
        };

        const filteredData = filteredStudents.map(student => ({
            Name: student.name,
            Nric: student.nric,
            Email: student.email,
            Phone: student.phone,
            Gender: student.gender,
            Dob: formatDate(student.dob),
            Password: student.password,
            Officephone: student.officephone,
            Address: student.address,
            Course: student.course,
            Citizenship: student.citizenship,
            Passport: student.passport,
            PassportExpiryDate: formatDate(student.passportExpiryDate),
            CurrentAddress: student.currentAddress,
            Religion: student.religion,
            ProfileUrl: student.profileUrl,
            Nricdoc: student.nricdoc,
            Educationdoc: student.educationdoc,
            Passportdoc: student.passportdoc,
            InstitutionDetails: student.institutionDetails.map(inst =>
                `${inst.institution} (From: ${formatDate(inst.fromYear)}, To: ${formatDate(inst.toYear)}, Language: ${inst.language}, Qualification: ${inst.qualificationsAchieved})`
            ).join('; '),
            WorkExperiences: student.workExpirences.map(exp =>
                `${exp.name} (Position: ${exp.position}, From: ${formatDate(exp.fromYear)}, To: ${formatDate(exp.toYear)}, Duties: ${exp.natureOfPosition},Country: ${exp.country})`
            ).join('; '),
            EmergencyContacts: student.emergencyContacts.map(contact =>
                `${contact.name} (Number: ${contact.number}, Relationship: ${contact.relationship}, Others: ${contact.othersRelationship})`
            ).join('; ')
        }));
        // Create Excel workbook and sheet
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Students');
        // Auto-width for columns
        const columnWidths = Object.keys(filteredData[0] || {}).map(key => ({
            wch: Math.max(
                key.length,
                ...filteredData.map(row => (row[key]?.toString().length || 10))
            ) + 2
        }));
        worksheet['!cols'] = columnWidths;
        // Generate and download Excel file
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'students.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };



    const [isFocused, setIsFocused] = useState(false);

    const handleEmergencyChange = (index, field, value) => {
        const updatedContacts = [...editedStudent.emergencyContacts];
        updatedContacts[index][field] = value;
        setEditedStudent({ ...editedStudent, emergencyContacts: updatedContacts });
    };

    const handleAddEmergency = () => {
        setEditedStudent({
            ...editedStudent,
            emergencyContacts: [
                ...editedStudent.emergencyContacts,
                { name: '', number: '', relationship: '', othersRelationship: '' },
            ],
        });
    };

    const handleRemoveEmergency = (index) => {
        const updatedContacts = [...editedStudent.emergencyContacts];
        updatedContacts.splice(index, 1);
        setEditedStudent({ ...editedStudent, emergencyContacts: updatedContacts });
    };

    const handleInstitutionChange = (index, e) => {
        const { name, value } = e.target;
        const newInstitutionDetails = editedStudent.institutionDetails.map((institution, i) => {
            if (i === index) {
                return { ...institution, [name]: value };
            }
            return institution;
        });
        setEditedStudent({ ...editedStudent, institutionDetails: newInstitutionDetails });
    };

    const handleAddEducation = () => {
        setEditedStudent({
            ...editedStudent,
            institutionDetails: [
                ...editedStudent.institutionDetails,
                { institution: '', fromYear: '', toYear: '', qualificationsAchieved: '', highest: false, language: '' },
            ],
        });
    };

    const handleRemoveEducation = (index) => {
        const newInstitutionDetails = editedStudent.institutionDetails.filter((_, i) => i !== index);
        setEditedStudent({ ...editedStudent, institutionDetails: newInstitutionDetails });
    };


    const handleWorkExperienceChange = (index, e) => {
        const { name, value } = e.target;
        const newWorkExperiences = editedStudent.workExpirences.map((experience, i) => {
            if (i === index) {
                return { ...experience, [name]: value };
            }
            return experience;
        });
        setEditedStudent({
            ...editedStudent,
            workExpirences: newWorkExperiences
        });
    };

    const handleAddWorkExperience = () => {
        setEditedStudent((prevState) => ({
            ...prevState,
            workExpirences: [
                ...prevState.workExpirences,
                { name: '', position: '', fromYear: '', toYear: '', country: '', natureOfPosition: '' }
            ]
        }));
        setShowEmploymentFields(true); // Show employment fields after adding
    };

    const handleRemoveWorkExperience = (index) => {
        const newWorkExperiences = editedStudent.workExpirences.filter((_, i) => i !== index);
        setEditedStudent({
            ...editedStudent,
            workExpirences: newWorkExperiences
        });
        if (newWorkExperiences.length === 0) {
            setShowEmploymentFields(false); // Hide employment fields if no experience entries
        }
    };


    const handlePdfEditcertificate = async (student) => {
        console.log(student)
        const pdfBytes = await fetch(Invitation).then((res) => res.arrayBuffer());
        const pdfDoc = await PDFDocument.load(pdfBytes);
        const pages = pdfDoc.getPages();
        const firstPage = pages[0];
        // const secondPage = pages[1];
        const fontSize = 12;

        const TimesRomanBoldFont = await pdfDoc.embedFont(StandardFonts.TimesRomanBold);
        const TimesRoman = await pdfDoc.embedFont(StandardFonts.TimesRoman);

        const passport = student.passport || ' ';
        const studentName = student.name || ' ';
        const course = student.course || ' ';

        // const currentDate = new Date().toISOString();
        const currentDate = student.offerDate;

        const wrapText = (text, maxWidth) => {
            const words = text.split(" ");
            let lines = [];
            let currentLine = words[0];

            for (let i = 1; i < words.length; i++) {
                const word = words[i];
                const width = TimesRoman.widthOfTextAtSize(`${currentLine} ${word}`, fontSize);

                if (width < maxWidth) {
                    currentLine += ` ${word}`;
                } else {
                    lines.push(currentLine);
                    currentLine = word;
                }
            }
            lines.push(currentLine);
            return lines;
        };
        const maxWidth = 460;
        const wrappedText = wrapText(
            `I am pleased to inform you that you have been admitted to Charisma University ${course}! Your student ID is ${passport} and your login information has been e-mailed to you.`,
            maxWidth
        );

        let yPosition = 522;  // Initial y position
        const lineSpacing = 15; // Adjust this value to reduce line spacing

        const formatDate = (dateString) => {
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const year = date.getFullYear();
            return `${day}.${month}.${year}`;
        };

        // Draw each line with reduced line spacing
        wrappedText.forEach((line) => {
            firstPage.drawText(line, {
                x: 73,
                y: yPosition,
                size: fontSize,
                font: TimesRoman,
                color: rgb(0, 0.1216, 0.3725),
            });
            yPosition -= lineSpacing; // Adjust y position for the next line
        });

        firstPage.drawText(`${studentName},`, { x: 99, y: 545.5, size: 12, font: TimesRoman, color: rgb(0, 0.1216, 0.3725), });
        firstPage.drawText(`${formatDate(currentDate)}`, { x: 480, y: 595.5, size: 12, font: TimesRoman, color: rgb(0, 0.1216, 0.3725), });


        const pdfBytesModified = await pdfDoc.save();
        const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    }

    const handleViewStudent = async (student) => {


        // try {
        //     // First API call
        //     const response = await axios.get(`/student/${student.id}`);
        const courseFees = student.courseFees && student.courseFees.length > 0 ? student.courseFees : [];
        setPaymentDetails(courseFees);
        setSelectedStudent(student);
        setShowModal(true);

        // } catch (error) {
        //     console.error('Error fetching student details:', error);
        // }
    };

    const handleCloseModal = () => {
        setShowModal(false);

    };


    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with leading zero if necessary
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1 and pad
        const year = date.getFullYear(); // Get full year

        return `${day}/${month}/${year}`;
    };

    const numberToWords = (number) => {
        const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
        const suffixes = ['', 'Thousand'];


        const numToWords = (num) => {
            let words = '';
            if (num >= 1000) {
                words += numToWords(Math.floor(num / 1000)) + ' Thousand ';
                num %= 1000;
            }
            if (num >= 100) {
                words += ones[Math.floor(num / 100)] + ' Hundred ';
                num %= 100;
            }
            if (num >= 20) {
                words += tens[Math.floor(num / 10)] + ' ';
                num %= 10;
            }
            if (num > 0) {
                if (num >= 11 && num <= 19) {
                    words += teens[num - 10] + ' ';
                } else {
                    words += ones[num] + ' ';
                }
            }
            return words.trim();
        };

        if (number === 0) return 'Zero';
        return numToWords(number);
    };

    const handledownloadReciept = async (selectedStudent, student) => {
        console.log("gfg:", student)
        const pdfBytes = await fetch(courserecipt).then((res) => res.arrayBuffer());
        const pdfDoc = await PDFDocument.load(pdfBytes);
        pdfDoc.registerFontkit(fontkit);
        const pages = pdfDoc.getPages();
        const firstPage = pages[0];
        // const courierfont = await pdfDoc.embedFont(StandardFonts.Courier);
        //const courierfontbold = await pdfDoc.embedFont(StandardFonts.CourierBold);
        const calibriFontBoldBytes = await fetch(TimesRoman).then((res) => res.arrayBuffer());
        const courierfont = await pdfDoc.embedFont(calibriFontBoldBytes);

        const amountText = student?.amount ? `$${(student.amount).toFixed(2)}` : ''; // Ensure the dollar symbol is always present
        const type = student?.feestype;
        let label = '';
        let labelX = 318;
        if (type === 'Registration fee') {
            label = 'Registration Fees';
            labelX = 317;
        } else if (type === 'Course fee') {
            label = 'Course Fees';
            labelX = 335;
        } else {
            label = '';
        }
        const balanceToDisplay = student?.feestype === 'Course fee'
            ? student?.courseFeebalance?.toFixed(2)
            : student?.registrationFeebalance?.toFixed(2);
        const sumOfDollars = numberToWords(student?.amount);
        // Convert numbers to strings
        firstPage.drawText(String(student?.studentName || '').toUpperCase(), { x: 128, y: 572, size: 10, font: courierfont, color: rgb(0, 0, 0) });
        firstPage.drawText(String(student?.finNric || ''), { x: 128, y: 558, size: 10, font: courierfont, color: rgb(0, 0, 0) });
        firstPage.drawText(String(selectedStudent?.studentIds || ''), { x: 133, y: 545, size: 10, font: courierfont, color: rgb(0, 0, 0) });
        firstPage.drawText(String(selectedStudent?.email || ''), { x: 115, y: 504, size: 10, font: courierfont, color: rgb(0, 0, 0) });
        function wrapText(text, font, fontSize, maxWidth) {
            const words = text.split(' ');
            const lines = [];
            let currentLine = '';
            for (let i = 0; i < words.length; i++) {
                const word = words[i];
                const testLine = currentLine ? currentLine + ' ' + word : word;
                const textWidth = font.widthOfTextAtSize(testLine, fontSize);
                if (textWidth <= maxWidth) {
                    currentLine = testLine;
                } else {
                    if (currentLine) lines.push(currentLine);
                    currentLine = word;
                }
            }
            if (currentLine) lines.push(currentLine);
            return lines;
        }
        // 3. Apply it in PDF-lib drawing
        const rawCourseName = student?.course || '';
        const cleanedCourseName = removeBracketedText(rawCourseName);
        const maxWidth = 150;
        const fontSize = 10;
        const startX = 128;
        let startY = 531;
        const lines = wrapText(cleanedCourseName, courierfont, fontSize, maxWidth);
        lines.forEach((line) => {
            firstPage.drawText(line, {
                x: startX,
                y: startY,
                size: fontSize,
                font: courierfont,
                color: rgb(0, 0, 0),
            });
            startY -= fontSize + 2; // Move down for the next line
        });
        // firstPage.drawText(String(feeDetail?.description || ''), { x: 35, y: 520, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
        firstPage.drawText(String(student?.invoiceNumber || ''), { x: 467, y: 569, size: 12, font: courierfont, color: rgb(0, 0, 0) });
        firstPage.drawText(String(formatDate(student?.date || '')), { x: 477, y: 466, size: 10, font: courierfont, color: rgb(0, 0, 0) });
        firstPage.drawText(amountText, { x: 485, y: 384, size: 10, font: courierfont, color: rgb(0, 0, 0) });
        firstPage.drawText(amountText, { x: 485, y: 319, size: 10, font: courierfont, color: rgb(0, 0, 0) });
        firstPage.drawText(label, { x: labelX, y: 371, size: 10, font: courierfont, color: rgb(0, 0, 0) });
        firstPage.drawText(String(formatDate(student?.date || '')), { x: 85, y: 384, size: 10, font: courierfont, color: rgb(0, 0, 0) });
        // firstPage.drawText(amountText, { x: 497, y: 460, size: 10, font: courierfont, color: rgb(0, 0, 0) });
        // firstPage.drawText(`${sumOfDollars} Dollars Only`, { x: 177, y: 464, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
        // firstPage.drawText("AUD", { x: 498, y: 438, size: 1, font: courierfont, color: rgb(0, 0, 0) });
        firstPage.drawText(`S$${balanceToDisplay}`, { x: 483, y: 291, size: 10, font: courierfont, color: rgb(0, 0, 0) });
        // const drawWrappedText = async (page, text, x, y, font, fontSize, maxWidth) => {
        //     text = replaceTabs(text);
        //     const lines = [];
        //     let currentLine = '';
        //     const words = text.split(' ');
        //     for (let i = 0; i < words.length; i++) {
        //         const word = words[i];
        //         const width = getTextWidth(currentLine + ' ' + word, font, fontSize);
        //         if (width < maxWidth) {
        //             currentLine += (currentLine === '' ? '' : ' ') + word;
        //         } else {
        //             lines.push(currentLine.trim());
        //             currentLine = word;
        //         }
        //     }
        //     if (currentLine !== '') {
        //         lines.push(currentLine.trim());
        //     }
        //     for (let i = 0; i < lines.length; i++) {
        //         const line = lines[i].trim();
        //         const lineWidth = getTextWidth(line, font, fontSize);
        //         await page.drawText(line, {
        //             x: i === 0 ? x : x,
        //             y: y - i * 12,
        //             size: fontSize,
        //             font,
        //             color: rgb(0, 0, 0),
        //         });
        //     }
        // };
        // function replaceTabs(text) {
        //     return text.replace(/\t/g, '    '); // Replace each tab with four spaces
        // }
        // const getTextWidth = (text, font, fontSize) => {
        //     const width = font.widthOfTextAtSize(text, fontSize);
        //     return width;
        // };
        // let yPosition = 520;
        // const lineHeight = 10;
        // drawWrappedText(firstPage, String(feeDetail?.description || ''), 77, yPosition, courierfontbold, 10, 380);
        // yPosition -= lineHeight;
        // drawWrappedText(firstPage, `${sumOfDollars} Dollars Only`, 177, 464, courierfontbold, 10, 300);
        const pdfBytesModified = await pdfDoc.save();
        const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    };

    return (
        <div>
            <div className="container" style={{ maxWidth: '1400px' }}>
                {loading ? (
                    <Loader />
                ) : (
                    <Paper sx={{ width: '100%', overflow: 'hidden' }}>

                        <Grid container spacing={2} alignItems="center" marginTop={'5px'} padding={' 7px 5px '}>
                            {/* Search Input */}
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    label="Search by Name"
                                    value={searchQuery}
                                    onChange={handleSearch}
                                    InputProps={{ style: { borderRadius: '8px' } }}
                                />
                            </Grid>
                            {/* Gender Filter Dropdown */}
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel>Filter by Gender</InputLabel>
                                    <Select
                                        value={filterGender}
                                        onChange={(e) => setFilterGender(e.target.value)}
                                        label="Filter by Gender"
                                        style={{ borderRadius: '8px' }}
                                    >
                                        <MenuItem value="">All</MenuItem>
                                        <MenuItem value="Male">Male</MenuItem>
                                        <MenuItem value="Female">Female</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            {/* Bulk Download Button */}
                            <Grid item xs={12} sm={4}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    onClick={handleBulkDownload}
                                    style={{
                                        textTransform: 'capitalize',
                                        borderRadius: '8px',
                                        padding: '15px 15px',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    Bulk Download
                                </Button>
                            </Grid>
                        </Grid>
                        <br />
                        <TableContainer
                            sx={{
                                overflowX: 'auto',
                                maxWidth: '100%',
                                '@media (min-width: 768px)': { // Apply styles for screens smaller than 768px (mobile)
                                    overflowX: 'unset', // Enable horizontal scroll
                                },
                            }}
                        >
                            <div style={{ maxHeight: '600px', overflowY: 'auto' }}>

                                <Table aria-label="sticky table">
                                    <TableHead style={{ backgroundColor: 'black', position: 'sticky', top: 0, zIndex: 1 }}>
                                        <TableRow>
                                            {columns.map((column) => (
                                                <TableCell
                                                    key={column.id}
                                                    align="left"
                                                    style={{ fontWeight: 'bold' }}
                                                >
                                                    {column.label}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredStudents
                                            .slice((currentPage - 1) * studentsPerPage, currentPage * studentsPerPage)
                                            .map((student, index) => (
                                                <TableRow key={student.id}>
                                                    <TableCell>{index + 1}</TableCell>
                                                    <TableCell>
                                                        <span

                                                            title={`${student.name} details`}

                                                            style={{ cursor: 'pointer', textDecoration: 'underline', color: 'blue' }}
                                                            onClick={() => openDetailsModal(student, false)} // Pass 'false' for read-only mode
                                                        >
                                                            {student.name}
                                                        </span>
                                                    </TableCell>
                                                    <TableCell>{student.studentIds || 'N/A'}</TableCell>
                                                    {/* <TableCell>
                                                        <img
                                                            src={student.profileUrl ? student.profileUrl :
                                                                student.gender === 'Male' ?
                                                                    'https://uxwing.com/wp-content/themes/uxwing/download/peoples-avatars/default-profile-picture-male-icon.png' :
                                                                    student.gender === 'Female' ?
                                                                        'https://cdn3.iconfinder.com/data/icons/business-vol-26/100/Artboard_2-512.png' :
                                                                        'https://static.vecteezy.com/system/resources/thumbnails/002/318/271/small/user-profile-icon-free-vector.jpg'}
                                                            alt="Profile"
                                                            style={{ width: '150px', height: '100px' }}
                                                        />
                                                    </TableCell> */}
                                                    <TableCell>{student.nric}</TableCell>
                                                    {/* <TableCell>
                                                        {student.nric
                                                            ? "*".repeat(student.nric.length - 4) + student.nric.slice(-4)
                                                            : "N/A"}
                                                    </TableCell> */}

                                                    <TableCell>{student.email}</TableCell>
                                                    <TableCell>{student.phone}</TableCell>
                                                    <TableCell>{student.gender}</TableCell>
                                                    <TableCell>
                                                        {student.offerDate ?
                                                            (() => {
                                                                const date = new Date(student.offerDate);
                                                                const day = String(date.getDate()).padStart(2, '0');
                                                                const month = String(date.getMonth() + 1).padStart(2, '0');
                                                                const year = date.getFullYear();
                                                                return `${day}-${month}-${year}`;
                                                            })()
                                                            : ''
                                                        }
                                                    </TableCell>
                                                    <TableCell style={{ width: '10%' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <BsPencilFill
                                                                style={{ marginRight: 10 }}
                                                                onClick={() => openDetailsModal(student, true)} // Pass 'true' for edit mode
                                                            />                    <DeleteRoundedIcon
                                                                style={{ color: 'red', marginLeft: 10 }}
                                                                onClick={() => handleDelete(student.id)}
                                                            />

                                                        </div>
                                                    </TableCell>
                                                    <TableCell><ApplicationForm ref={applicationFormRef} />
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={() => handleApplicationForm(student)} // Calls the function from ApplicationForm
                                                        > Application
                                                        </Button>
                                                    </TableCell>
                                                    {/* <TableCell>
                                                        <OfferLetter ref={offerLetterRef} />
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={() => handleOfferForm(student)}
                                                        >
                                                            offer
                                                        </Button>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            // style={{ marginBottom: '10px', width: '45%', maxWidth: '180px' }}
                                                            // startIcon={<FontAwesomeIcon icon={faGraduationCap} />}
                                                            onClick={() => handlePdfEditcertificate(student)}
                                                        >
                                                            Invitation
                                                        </Button>
                                                    </TableCell> */}
                                                    <TableCell>
                                                        <Button variant="contained" onClick={() => handleViewStudent(student)}>
                                                            View
                                                        </Button>

                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            count={filteredStudents.length}
                            rowsPerPage={studentsPerPage}
                            page={currentPage - 1}
                            labelDisplayedRows={({ from, to }) => `${from}-${to} Page No ${currentPage}`}
                            onPageChange={(event, newPage) => setCurrentPage(newPage + 1)}
                            onRowsPerPageChange={(event) => {
                                setCurrentPage(1);
                                setStudentsPerPage(event.target.value);
                            }}
                        />
                    </Paper>
                )}
            </div>

            <Modal
                show={showModal}
                onHide={handleCloseModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                fullscreen
            >
                <Modal.Header closeButton>
                    {/* <Modal.Title>Student Details</Modal.Title> */}
                    {/* <Button onClick={handleDownloadPDF} variant="contained" color="primary">Download PDF</Button> */}
                </Modal.Header>
                <Modal.Body>
                    <div id="modalContent">
                        {paymentDetails && paymentDetails.length > 0 ? (
                            <>
                                <Grid item xs={10} md={6}>
                                    <Paper elevation={3} style={{ padding: '24px', height: '100%' }}>
                                        <Typography variant="h6" gutterBottom style={{ fontWeight: 'bolder' }}>Payment Details</Typography>
                                        <TableContainer>
                                            <Grid item xs={12} md={6}>
                                                <Paper elevation={3} style={{ padding: '24px', height: '100%' }}>
                                                    <div >
                                                        <div>
                                                            <Typography variant="h6" component="div" gutterBottom>
                                                                Course Fee Details
                                                            </Typography>
                                                            <TableContainer component={Paper}>
                                                                <Table aria-label="Registration fee details table">
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell>Invoice Number</TableCell>
                                                                            <TableCell>Date</TableCell>
                                                                            <TableCell>Amount Paid</TableCell>
                                                                            <TableCell>Discount</TableCell>
                                                                            <TableCell>Description</TableCell>
                                                                            <TableCell>Action</TableCell>


                                                                            {/* <TableCell>Fee Type</TableCell> */}
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {paymentDetails.filter(feeDetail => feeDetail.feestype === "Course fee").length > 0 ? (
                                                                            paymentDetails
                                                                                .filter(feeDetail => feeDetail.feestype === "Course fee")
                                                                                .map((feeDetail, index) => (
                                                                                    <TableRow key={index}>
                                                                                        <TableCell>{feeDetail.invoiceNumber}</TableCell>
                                                                                        <TableCell>{formatDate(feeDetail.date)}</TableCell>
                                                                                        <TableCell>${feeDetail.amount}</TableCell>
                                                                                        <TableCell>{feeDetail.discount ? `$${feeDetail.discount}` : "NA"}</TableCell>
                                                                                        <TableCell>{feeDetail.description}</TableCell>
                                                                                        <TableCell>
                                                                                            <Button
                                                                                                variant="contained"
                                                                                                color="primary"
                                                                                                onClick={() => handledownloadReciept(selectedStudent, feeDetail)}
                                                                                            >
                                                                                                View Receipt
                                                                                            </Button>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                ))
                                                                        ) : (
                                                                            <TableRow>
                                                                                <TableCell colSpan={6} align="center">
                                                                                    No data available
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        )}
                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer>

                                                            <Typography variant="h6" component="div" gutterBottom style={{ marginTop: '20px' }}>
                                                                Registration Fee Details
                                                            </Typography>
                                                            <TableContainer component={Paper}>
                                                                <Table aria-label="Course Fee table">
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell style={{ fontWeight: 'bold' }}>Invoice Number</TableCell>
                                                                            <TableCell style={{ fontWeight: 'bold' }}>Date</TableCell>
                                                                            <TableCell style={{ fontWeight: 'bold' }}>Amount Paid</TableCell>
                                                                            <TableCell style={{ fontWeight: 'bold' }}>Description</TableCell>
                                                                            <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {paymentDetails.filter(feeDetail => feeDetail.feestype === "Registration fee").length > 0 ? (
                                                                            paymentDetails
                                                                                .filter(feeDetail => feeDetail.feestype === "Registration fee")
                                                                                .map((feeDetail, index) => (
                                                                                    <TableRow key={index}>
                                                                                        <TableCell>{feeDetail.invoiceNumber}</TableCell>
                                                                                        <TableCell>{formatDate(feeDetail.date)}</TableCell>
                                                                                        <TableCell>${feeDetail.amount}</TableCell>
                                                                                        <TableCell>{feeDetail.description}</TableCell>
                                                                                        <TableCell>
                                                                                            <Button
                                                                                                variant="contained"
                                                                                                color="primary"
                                                                                                onClick={() => handledownloadReciept(selectedStudent, feeDetail)}
                                                                                            >
                                                                                                View Receipt
                                                                                            </Button>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                ))
                                                                        ) : (
                                                                            <TableRow>
                                                                                <TableCell colSpan={5} align="center">
                                                                                    No data available
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        )}
                                                                    </TableBody>

                                                                </Table>
                                                            </TableContainer>
                                                        </div>
                                                    </div>

                                                    {/* <div style={{ marginTop: '20px' }}>
                            <App ref={childRef} dataProp={dataForprop} />
                            <Button variant="contained" color="primary" onClick={handleContractletter}>Student Contract</Button>
                            <span style={{ marginRight: '10px' }}></span>
                            <AdmissionOffer ref={admissionOfferRef} dataProp={dataForprop} />
                            <Button variant="contained" color="primary" onClick={handleOfferletter}>Offer Letter</Button>
                            <span style={{ marginRight: '10px' }}></span>
                            <ApplicationForm ref={applicationFormRef} dataProp={dataForprop} studentInfo={studentInfo} />
                            <Button variant="contained" color="primary" onClick={handleApplicationForm}>Application Form</Button>
                          </div> */}
                                                </Paper>
                                            </Grid>

                                        </TableContainer>
                                    </Paper>
                                </Grid>

                            </>
                        ) : (
                            <Typography variant="h6" style={{ textAlign: 'center', margin: '20px' }}>
                                No payment details available for this student.
                            </Typography>
                        )}
                    </div>


                </Modal.Body>
            </Modal>


            <Dialog open={isEditModalOpen} onClose={closeEditModal}>
                <DialogTitle>
                    {isReadOnly ? 'Student Details' : 'Edit Student (Newton International College)'}
                </DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSaveEdit}>
                        <Grid container spacing={3}>
                            {/* Personal Information Section */}
                            <Grid item xs={12}>
                                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                                    Personal Information
                                </Typography>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Full Name"
                                    name="fullname"
                                    required
                                    fullWidth
                                    value={editedStudent?.name || ''}
                                    onChange={(e) => {
                                        if (!isReadOnly) {
                                            const inputValue = e.target.value.replace(/[^A-Za-z\s]/g, '');
                                            const truncatedValue = inputValue.substring(0, 25);
                                            if (truncatedValue.trim() !== '' || truncatedValue.length === 0) {
                                                setEditedStudent({
                                                    ...editedStudent,
                                                    name: truncatedValue,
                                                });
                                            }
                                        }
                                    }}
                                    margin="normal"
                                    InputProps={{ readOnly: isReadOnly }}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="NRIC/FIN No*"
                                    name="nric"
                                    fullWidth
                                    value={editedStudent?.nric || ''}
                                    onChange={(e) => {
                                        if (!isReadOnly) {
                                            const inputValue = e.target.value.replace(/[^A-Za-z0-9]/g, '').substring(0, 9);
                                            setEditedStudent({
                                                ...editedStudent,
                                                nric: inputValue,
                                            });
                                        }
                                    }}
                                    margin="normal"
                                    InputProps={{ readOnly: isReadOnly }}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Email*"
                                    name="email"
                                    type="email"
                                    fullWidth
                                    value={editedStudent?.email || ''}
                                    onChange={(e) => {
                                        if (!isReadOnly) {
                                            setEditedStudent({
                                                ...editedStudent,
                                                email: e.target.value,
                                            });
                                        }
                                    }}
                                    margin="normal"
                                    InputProps={{ readOnly: isReadOnly }}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Course Fee*"
                                    name="courseFee"
                                    type="number"
                                    fullWidth
                                    value={editedStudent?.courseFee || ''}
                                    onChange={(e) => {
                                        if (!isReadOnly) {
                                            setEditedStudent({
                                                ...editedStudent,
                                                courseFee: e.target.value,
                                            });
                                        }
                                    }}
                                    margin="normal"
                                    InputProps={{
                                        readOnly: isReadOnly,
                                        startAdornment: <InputAdornment position="start">$</InputAdornment>
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Passport*"
                                    name="passport"
                                    fullWidth
                                    value={editedStudent?.passport || ''}
                                    onChange={(e) => {
                                        if (!isReadOnly) {
                                            setEditedStudent({
                                                ...editedStudent,
                                                passport: e.target.value,
                                            });
                                        }
                                    }}
                                    margin="normal"
                                    InputProps={{ readOnly: isReadOnly }}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <TextField
                                    type="date"
                                    label="Passport Expiry Date*"
                                    name="passportexpiredate"
                                    fullWidth
                                    value={editedStudent?.passportExpiryDate || ''}
                                    onChange={(e) => {
                                        if (!isReadOnly) {
                                            setEditedStudent({
                                                ...editedStudent,
                                                passportExpiryDate: e.target.value,
                                            });
                                        }
                                    }}
                                    margin="normal"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{ readOnly: isReadOnly }}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Citizenship*"
                                    name="citizenship"
                                    fullWidth
                                    value={editedStudent?.citizenship || ''}
                                    onChange={(e) => {
                                        if (!isReadOnly) {
                                            setEditedStudent({
                                                ...editedStudent,
                                                citizenship: e.target.value,
                                            });
                                        }
                                    }}
                                    margin="normal"
                                    InputProps={{ readOnly: isReadOnly }}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <TextField
                                    type="date"
                                    label="Documents Date*"
                                    name="offerDate"
                                    fullWidth
                                    value={editedStudent?.offerDate || ''}
                                    onChange={(e) => {
                                        if (!isReadOnly) {
                                            setEditedStudent({
                                                ...editedStudent,
                                                offerDate: e.target.value,
                                            });
                                        }
                                    }}
                                    margin="normal"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{ readOnly: isReadOnly }}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Course*"
                                    name="course"
                                    fullWidth
                                    value={editedStudent?.course || ''}
                                    margin="normal"
                                    InputProps={{ readOnly: true }}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth margin="normal" disabled={isReadOnly}>
                                    <InputLabel id="gender-label">Gender*</InputLabel>
                                    <Select
                                        labelId="gender-label"
                                        id="gender"
                                        value={editedStudent?.gender || ''}
                                        onChange={(e) => {
                                            if (!isReadOnly) {
                                                setEditedStudent({
                                                    ...editedStudent,
                                                    gender: e.target.value,
                                                });
                                            }
                                        }}
                                        label="Gender*"
                                    >
                                        <MenuItem value="">Select Gender</MenuItem>
                                        <MenuItem value="Male">Male</MenuItem>
                                        <MenuItem value="Female">Female</MenuItem>
                                        <MenuItem value="Other">Other</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Date of Birth*"
                                    type="date"
                                    name="dob"
                                    fullWidth
                                    value={editedStudent?.dob || '2000-01-01'}
                                    onChange={(e) => {
                                        if (!isReadOnly) {
                                            setEditedStudent({
                                                ...editedStudent,
                                                dob: e.target.value,
                                            });
                                        }
                                    }}
                                    margin="normal"
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{
                                        min: '1920-01-01',
                                        max: '2012-12-31',
                                        readOnly: isReadOnly,
                                    }}
                                    disabled={isReadOnly}
                                />
                            </Grid>

                            {/* Contact Information Section */}
                            <Grid item xs={12} mt={3}>
                                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                                    Contact Information
                                </Typography>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Home Phone*"
                                    name="phone"
                                    fullWidth
                                    value={editedStudent?.phone || ''}
                                    onChange={(e) => {
                                        if (!isReadOnly) {
                                            const inputValue = e.target.value.replace(/[^0-9]/g, '').substring(0, 10);
                                            setEditedStudent({
                                                ...editedStudent,
                                                phone: inputValue,
                                            });
                                        }
                                    }}
                                    margin="normal"
                                    InputProps={{ readOnly: isReadOnly }}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Office Phone"
                                    name="officephone"
                                    fullWidth
                                    value={editedStudent?.officephone || ''}
                                    onChange={(e) => {
                                        if (!isReadOnly) {
                                            const inputValue = e.target.value.replace(/[^0-9]/g, '').substring(0, 10);
                                            setEditedStudent({
                                                ...editedStudent,
                                                officephone: inputValue,
                                            });
                                        }
                                    }}
                                    margin="normal"
                                    InputProps={{ readOnly: isReadOnly }}
                                />
                            </Grid>

                            {/* <Grid item xs={12} md={6}>
                                <TextField
                                    label="Password*"
                                    name="password"
                                    type={showPassword ? 'text' : 'password'}
                                    fullWidth
                                    value={editedStudent?.password || ''}
                                    onChange={(e) => {
                                        if (!isReadOnly) {
                                            setEditedStudent({
                                                ...editedStudent,
                                                password: e.target.value,
                                            });
                                        }
                                    }}
                                    margin="normal"
                                    InputProps={{
                                        readOnly: isReadOnly,
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={togglePasswordVisibility}
                                                    edge="end"
                                                    disabled={isReadOnly}
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid> */}

                            {/* Address Information Section */}
                            <Grid item xs={12} mt={3}>
                                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                                    Address Information
                                </Typography>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Home Address*"
                                    name="address"
                                    fullWidth
                                    value={editedStudent?.address || ''}
                                    onChange={(e) => {
                                        if (!isReadOnly) {
                                            setEditedStudent({
                                                ...editedStudent,
                                                address: e.target.value,
                                            });
                                        }
                                    }}
                                    margin="normal"
                                    InputProps={{ readOnly: isReadOnly }}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Singapore Address"
                                    name="currentAddress"
                                    fullWidth
                                    value={editedStudent?.currentAddress || ''}
                                    onChange={(e) => {
                                        if (!isReadOnly) {
                                            setEditedStudent({
                                                ...editedStudent,
                                                currentAddress: e.target.value,
                                            });
                                        }
                                    }}
                                    margin="normal"
                                    InputProps={{ readOnly: isReadOnly }}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Postal Code*"
                                    name="postalcode"
                                    fullWidth
                                    value={editedStudent?.postalcode || ''}
                                    onChange={(e) => {
                                        if (!isReadOnly) {
                                            const inputValue = e.target.value.replace(/[^0-9]/g, '').substring(0, 6);
                                            setEditedStudent({
                                                ...editedStudent,
                                                postalcode: inputValue,
                                            });
                                        }
                                    }}
                                    margin="normal"
                                    InputProps={{ readOnly: isReadOnly }}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Religion*"
                                    name="religion"
                                    fullWidth
                                    value={editedStudent?.religion || ''}
                                    onChange={(e) => {
                                        if (!isReadOnly) {
                                            setEditedStudent({
                                                ...editedStudent,
                                                religion: e.target.value,
                                            });
                                        }
                                    }}
                                    margin="normal"
                                    InputProps={{ readOnly: isReadOnly }}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Sign Date"
                                    type="date"
                                    name="signDate"
                                    fullWidth
                                    value={editedStudent?.signDate || ''}
                                    onChange={(e) => {
                                        if (!isReadOnly) {
                                            setEditedStudent({
                                                ...editedStudent,
                                                signDate: e.target.value,
                                            });
                                        }
                                    }}
                                    margin="normal"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{ readOnly: isReadOnly }}
                                />
                            </Grid>

                            {/* Document Upload Section */}
                            <Grid item xs={12} mt={3}>
                                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                                    Document Uploads
                                </Typography>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Typography variant="subtitle1">Upload photo</Typography>
                                <TextField
                                    type="file"
                                    id="profileUpload"
                                    fullWidth
                                    accept="image/png, image/jpeg, image/jpg"
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (!file) return;
                                        const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
                                        if (file.size > 8 * 1024 * 1024) {
                                            e.target.value = "";
                                            toast.error("File size must be less than 8MB.");
                                        } else if (!allowedTypes.includes(file.type)) {
                                            e.target.value = "";
                                            toast.error("Invalid file type. Only PNG, JPG, or JPEG are allowed.");
                                        } else {
                                            setSelectedProfileFile(file);
                                        }
                                    }}
                                    variant="outlined"
                                    style={{ marginTop: '8px' }}
                                    disabled={isReadOnly}
                                />
                                {editedStudent?.profileUrl && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        href={editedStudent.profileUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ marginTop: '8px', color: 'white' }}
                                    >
                                        View
                                    </Button>
                                )}
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Typography variant="subtitle1">Upload NRIC</Typography>
                                <TextField
                                    type="file"
                                    id="nricUpload"
                                    fullWidth
                                    accept="application/pdf"
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (!file) return;
                                        const allowedTypes = ['application/pdf'];
                                        if (file.size > 8 * 1024 * 1024) {
                                            e.target.value = "";
                                            toast.error("File size must be less than 8MB.");
                                        } else if (!allowedTypes.includes(file.type)) {
                                            e.target.value = "";
                                            toast.error("Invalid file type. Only PDF files are allowed.");
                                        } else {
                                            setSelectedNricFile(file);
                                        }
                                    }}
                                    variant="outlined"
                                    style={{ marginTop: '8px' }}
                                    disabled={isReadOnly}
                                />
                                {editedStudent?.nricdoc && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        href={editedStudent.nricdoc}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ marginTop: '8px', color: 'white' }}
                                    >
                                        View NRIC Document
                                    </Button>
                                )}
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Typography variant="subtitle1">Upload Passport</Typography>
                                <TextField
                                    type="file"
                                    id="passportUpload"
                                    accept="application/pdf"
                                    fullWidth
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (!file) return;
                                        const allowedTypes = ['application/pdf'];
                                        if (file.size > 8 * 1024 * 1024) {
                                            e.target.value = "";
                                            toast.error("File size must be less than 8MB.");
                                        } else if (!allowedTypes.includes(file.type)) {
                                            e.target.value = "";
                                            toast.error("Invalid file type. Only PDF files are allowed.");
                                        } else {
                                            setSelectedPassportFile(file);
                                        }
                                    }}
                                    variant="outlined"
                                    style={{ marginTop: '8px' }}
                                    disabled={isReadOnly}
                                />
                                {editedStudent?.passportdoc && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        href={editedStudent.passportdoc}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ marginTop: '8px', color: 'white' }}
                                    >
                                        View Passport Document
                                    </Button>
                                )}
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Typography variant="subtitle1">Upload Education Document</Typography>
                                <TextField
                                    type="file"
                                    id="educationUpload"
                                    fullWidth
                                    accept="application/pdf"
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (!file) return;
                                        const allowedTypes = ['application/pdf'];
                                        if (file.size > 8 * 1024 * 1024) {
                                            e.target.value = "";
                                            toast.error("File size must be less than 8MB.");
                                        } else if (!allowedTypes.includes(file.type)) {
                                            e.target.value = "";
                                            toast.error("Invalid file type. Only PDF files are allowed.");
                                        } else {
                                            setSelectedEducationFile(file);
                                        }
                                    }}
                                    variant="outlined"
                                    style={{ marginTop: '8px' }}
                                    disabled={isReadOnly}
                                />
                                {editedStudent?.educationdoc && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        href={editedStudent.educationdoc}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ marginTop: '8px', color: 'white' }}
                                    >
                                        View Education Document
                                    </Button>
                                )}
                            </Grid>

                            {/* Educational Details Section */}
                            <Grid item xs={12} mt={3}>
                                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                                    Educational Details
                                </Typography>
                            </Grid>

                            {editedStudent.institutionDetails?.map((institution, index) => (
                                <Grid item xs={12} key={index}>
                                    <Card variant="outlined" sx={{ p: 2, mb: 2 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                            <Checkbox
                                                id={`highest-${index}`}
                                                checked={!!institution.highest}
                                                onChange={(e) => {
                                                    const updatedInstitutions = editedStudent.institutionDetails.map((inst, i) => ({
                                                        ...inst,
                                                        highest: i === index ? e.target.checked : false, // Only one can be true
                                                    }));
                                                    setEditedStudent({ ...editedStudent, institutionDetails: updatedInstitutions });
                                                }}
                                                disabled={isReadOnly}
                                            />
                                            <label htmlFor={`highest-${index}`}>Mark as Highest Qualification</label>
                                        </Box>

                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    fullWidth
                                                    label="Institution Name"
                                                    name="institution"
                                                    value={institution.institution}
                                                    onChange={(e) => handleInstitutionChange(index, e)}
                                                    InputProps={{ readOnly: isReadOnly }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    fullWidth
                                                    label="Degree"
                                                    name="qualificationsAchieved"
                                                    value={institution.qualificationsAchieved}
                                                    onChange={(e) => handleInstitutionChange(index, e)}
                                                    InputProps={{ readOnly: isReadOnly }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    fullWidth
                                                    label="Country"
                                                    name="country"
                                                    value={institution.country}
                                                    onChange={(e) => handleInstitutionChange(index, e)}
                                                    InputProps={{ readOnly: isReadOnly }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    fullWidth
                                                    label="From Year"
                                                    name="fromYear"
                                                    value={institution.fromYear}
                                                    onChange={(e) => handleInstitutionChange(index, e)}
                                                    InputProps={{ readOnly: isReadOnly }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    fullWidth
                                                    label="To Year"
                                                    name="toYear"
                                                    value={institution.toYear}
                                                    onChange={(e) => handleInstitutionChange(index, e)}
                                                    InputProps={{ readOnly: isReadOnly }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    fullWidth
                                                    label="Language of Instruction"
                                                    name="language"
                                                    value={institution.language}
                                                    onChange={(e) => handleInstitutionChange(index, e)}
                                                    InputProps={{ readOnly: isReadOnly }}
                                                />
                                            </Grid>
                                        </Grid>

                                        {!isReadOnly && (
                                            <Button
                                                variant="outlined"
                                                color="error"
                                                onClick={() => handleRemoveEducation(index)}
                                                startIcon={<DeleteIcon />}
                                                sx={{ mt: 2 }}
                                            >
                                                Remove Education
                                            </Button>
                                        )}
                                    </Card>
                                </Grid>
                            ))}

                            {!isReadOnly && (
                                <Grid item xs={12}>
                                    <Button
                                        variant="contained"
                                        onClick={handleAddEducation}
                                        startIcon={<AddIcon />}
                                    >
                                        Add Education
                                    </Button>
                                </Grid>
                            )}

                            {/* Work Experience Section */}
                            <Grid item xs={12} mt={3}>
                                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                                    Work Experience
                                </Typography>
                            </Grid>

                            {editedStudent.workExpirences?.map((experience, index) => (
                                <Grid item xs={12} key={index}>
                                    <Card variant="outlined" sx={{ p: 2, mb: 2 }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    fullWidth
                                                    label="Company Name"
                                                    name="name"
                                                    value={experience.name}
                                                    onChange={(e) => handleWorkExperienceChange(index, e)}
                                                    InputProps={{ readOnly: isReadOnly }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    fullWidth
                                                    label="Position"
                                                    name="position"
                                                    value={experience.position}
                                                    onChange={(e) => handleWorkExperienceChange(index, e)}
                                                    InputProps={{ readOnly: isReadOnly }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    type="number"
                                                    label="From Year"
                                                    name="fromYear"
                                                    value={experience.fromYear}
                                                    onChange={(e) => handleWorkExperienceChange(index, e)}
                                                    fullWidth
                                                    InputProps={{ readOnly: isReadOnly }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    type="number"
                                                    label="To Year"
                                                    name="toYear"
                                                    value={experience.toYear}
                                                    onChange={(e) => handleWorkExperienceChange(index, e)}
                                                    fullWidth
                                                    InputProps={{ readOnly: isReadOnly }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    label="Nature of Duties"
                                                    name="natureOfPosition"
                                                    value={experience.natureOfPosition}
                                                    onChange={(e) => handleWorkExperienceChange(index, e)}
                                                    fullWidth
                                                    InputProps={{ readOnly: isReadOnly }}
                                                />
                                            </Grid>
                                        </Grid>

                                        {!isReadOnly && (
                                            <Button
                                                variant="outlined"
                                                color="error"
                                                onClick={() => handleRemoveWorkExperience(index)}
                                                startIcon={<DeleteIcon />}
                                                sx={{ mt: 2 }}
                                            >
                                                Remove Experience
                                            </Button>
                                        )}
                                    </Card>
                                </Grid>
                            ))}

                            {!isReadOnly && (
                                <Grid item xs={12}>
                                    <Button
                                        variant="contained"
                                        onClick={handleAddWorkExperience}
                                        startIcon={<AddIcon />}
                                    >
                                        Add Work Experience
                                    </Button>
                                </Grid>
                            )}

                            {/* Emergency Contacts Section */}
                            <Grid item xs={12} mt={3}>
                                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                                    Emergency Contacts
                                </Typography>
                            </Grid>

                            {editedStudent.emergencyContacts?.map((contact, index) => (
                                <Grid item xs={12} key={index}>
                                    <Card variant="outlined" sx={{ p: 2, mb: 2 }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={6}>
                                                <FormControl fullWidth>
                                                    <InputLabel>Relationship</InputLabel>
                                                    <Select
                                                        value={contact.relationship}
                                                        onChange={(e) => handleEmergencyChange(index, 'relationship', e.target.value)}
                                                        label="Relationship"
                                                        disabled={isReadOnly}
                                                    >
                                                        <MenuItem value="">-- Select Relationship --</MenuItem>
                                                        <MenuItem value="Father">Father</MenuItem>
                                                        <MenuItem value="Mother">Mother</MenuItem>
                                                        <MenuItem value="Brother">Brother</MenuItem>
                                                        <MenuItem value="Sister">Sister</MenuItem>
                                                        <MenuItem value="Others">Others</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>

                                            {contact.relationship === 'Others' && (
                                                <Grid item xs={12} md={6}>
                                                    <TextField
                                                        label="Relationship with Applicant"
                                                        value={contact.othersRelationship}
                                                        onChange={(e) => handleEmergencyChange(index, 'othersRelationship', e.target.value)}
                                                        fullWidth
                                                        InputProps={{ readOnly: isReadOnly }}
                                                    />
                                                </Grid>
                                            )}

                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    label="Name"
                                                    value={contact.name}
                                                    onChange={(e) => handleEmergencyChange(index, 'name', e.target.value)}
                                                    fullWidth
                                                    InputProps={{ readOnly: isReadOnly }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    label="Contact No"
                                                    value={contact.number}
                                                    onChange={(e) => handleEmergencyChange(index, 'number', e.target.value)}
                                                    inputProps={{ maxLength: 10 }}
                                                    fullWidth
                                                    InputProps={{ readOnly: isReadOnly }}
                                                />
                                            </Grid>
                                        </Grid>

                                        {!isReadOnly && (
                                            <Button
                                                variant="outlined"
                                                color="error"
                                                onClick={() => handleRemoveEmergency(index)}
                                                startIcon={<DeleteIcon />}
                                                sx={{ mt: 2, float: 'right' }}
                                            >
                                                Remove Contact
                                            </Button>
                                        )}
                                    </Card>
                                </Grid>
                            ))}

                            {!isReadOnly && (
                                <Grid item xs={12}>
                                    <Button
                                        variant="contained"
                                        onClick={handleAddEmergency}
                                        startIcon={<AddIcon />}
                                    >
                                        Add Emergency Contact
                                    </Button>
                                </Grid>
                            )}


                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions>
                    {!isReadOnly && ( // Conditionally render the Update button based on read-only mode
                        <Button onClick={handleSaveEdit} variant="contained" color="primary" style={{ backgroundColor: 'green', color: 'white' }}>
                            Update
                        </Button>
                    )}
                    <Button onClick={closeEditModal} variant="contained" color="secondary" style={{ backgroundColor: 'red', color: 'white' }}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar />
            <DeleteConfirmationModal
                show={showDeleteModal}
                handleClose={handleCloseDeleteModal}
                handleConfirm={handleConfirmDelete}
            />
<StudentDetailsModal
  open={showProfileModal}
  onClose={() => { setShowProfileModal(false); setProfileStudentData(null); }}
  studentData={profileStudentData}
  loading={profileLoading}
/>

        </div >


    );
};


const New = () => {
    const [tabValue, setTabValue] = useState(0);

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };



    const handleTabChange = (newValue) => {
        setTabValue(newValue);
    };

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <div>
            <Header />
            <br />
            <div className="d-flex justify-content-center mt-4">
                <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    aria-label="Students-tabs"
                    variant="fullWidth"
                    sx={{
                        borderRadius: 10,
                        display: 'flex',
                        justifyContent: 'center',
                        "& button": {
                            borderRadius: 10,
                            color: "#555",

                            margin: 'auto',
                            display: 'block'
                        },
                        "& button:hover": {
                            backgroundColor: "#eee",
                        },
                        "& button:active": {
                            backgroundColor: "#ddd",
                        },
                        "& button.Mui-selected": {
                            backgroundColor: "#007bff",
                            color: "#fff",
                        },
                        "& .MuiTabs-indicator": {
                            display: 'none', // Remove the underline
                        },
                        ...(isMobile && {
                            flexDirection: 'column', // Stack tabs vertically
                            "& button": {
                                width: '100%', // Set tabs to full width on mobile
                            },
                        }),
                    }}
                >
                    <Tab label="All Students" sx={{ minWidth: isMobile ? '50%' : '620px' }} />
                    <Tab label="New Student" sx={{ minWidth: isMobile ? '50%' : '620px' }} />
                </Tabs>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                {tabValue === 0 && <Screen />}
                {tabValue === 1 && <Newstudent onFormSubmit={() => handleTabChange(0)} />}
            </div>

            
            {/* <div
        style={{
          position: 'absolute',
          bottom: '30px', // Adjust to desired distance from the bottom
          right: '30px', // Adjust to desired distance from the right
          opacity: 0.5, // Transparency for the image
          zIndex: 1, // Ensure it is below other UI elements
          pointerEvents: 'none',
        }}
      >
        <img
         src={Charisma}
          alt="Charisma"
          style={{
            maxWidth: '120px', // Adjust the size as needed
            maxHeight: '120px',
          }}
        />
      </div> */}
        </div>
    );



};

export default New;